/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ToastContainer, toast } from 'react-toastify';

import { getUrlSync } from '@msdyn365-commerce/core';

import { CartLine, SalesOrder } from '@msdyn365-commerce/retail-proxy';
import { getOrderHistoryAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CustomersDataActions.g';

import {
    getContactDetailsAsync,
    createOrUpdateBTGPDraftAsync,
    getAllBTGPCartLineAsync,
    getByCustomerBTGPTransactionAsync,
    getAllBTGPDraftAsync,
    getRenewableSerialsAsync,
    checkAvailableSerialAsync
} from '../../actions/DataActionExtension.g';
import { FormDetails } from '../../actions/ecomm-interfaces';
import { generateErrorLog } from '../../actions/helper-functions';

import { isMobile } from '../../components/breakpoints';

import { v4 as uuidv4 } from 'uuid';

import { Popup } from './component/popup';

import resource from './resources/resource.json';

import { ProductDetailsAddtoCartButton } from './component/ecomm-form-add-to-cart.component';

import AmountDeceasedNameForm from './formsComponents/amountDeceasedNameForm.component';
import CategoryNamesForm from './formsComponents/categoryNamesForm.component';
import CategoryNamesAddressForm from './formsComponents/categoryNamesAddressForm.component';
import CategoryNamesCollectionForm from './formsComponents/categoryNamesCollectionForm.component';
import CeremonyForm from './formsComponents/ceremonyForm.component';
import DeceasedCategoryNamesForm from './formsComponents/deceasedCategoryNamesForm.component';
import DeceasedDedicatedByForm from './formsComponents/deceasedDedicatedByForm.component';
import DonationForm from './formsComponents/donationForm.component';
import EventCategoryNamesForm from './formsComponents/eventCategoryNamesForm.component';
import EventDeceasedDedicatedByForm from './formsComponents/eventDeceasedDedicatedByForm.component';
import EventTaxDeductionForm from './formsComponents/eventTaxDeductionForm.component';
import NameBirthDatetimeForm from './formsComponents/nameBirthDatetimeForm.component';
import NameBirthdaySchoolForm from './formsComponents/nameBirthdaySchoolForm.component';
import NamesOnlyForm from './formsComponents/namesOnlyForm.component';
import NoOfYearsCategoryNamesForm from './formsComponents/noOfYearsCategoryNamesForm.component';
import OfferingForm from './formsComponents/offeringForm.component';
import ServicesBusinessForm from './formsComponents/servicesBusinessForm.component';
import ServicesDeceasedForm from './formsComponents/servicesDeceasedForm.component';
import ServicesEducationForm from './formsComponents/servicesEducationForm.component';
import ServicesGeneralForm from './formsComponents/servicesGeneralForm.component';
import ServicesHealthSurgeryForm from './formsComponents/servicesHealthSurgeryForm.component';
import ServicesInfantSpiritForm from './formsComponents/servicesInfantSpiritForm.component';
import ServicesMarriageForm from './formsComponents/servicesMarriageForm.component';
import ThreeCategoryNamesForm from './formsComponents/threeCategoryNamesForm.component';
import ThreeCategoryNamesConsecrationForm from './formsComponents/threeCategoryNamesConsecrationForm.component';
//import { IEcommProductDetailsFormViewProps } from './ecomm-product-details-form';
import EventPassportUploadForm from './formsComponents/eventsPassportUploadForm.component';
import EventPassportUploadInsuranceForm from './formsComponents/eventPassportUploadInsuranceForm.component';
import NamesDedicationStartDateForm from './formsComponents/nameDedicationStartDate.component';

//import { IEvent } from './ecomm-product-details-form.data';
import { IEcommProductDetailsFormViewProps } from './ecomm-product-details-form';
import moment from 'moment';
import CoursesForm from './formsComponents/coursesForm.component';
import EventChineseNameForm from './formsComponents/eventsChineseNameForm.component';
import EventNextOfKinNameForm from './formsComponents/eventsNextOfKinNameForm.component';
import NamesAddressContactnoForm from './formsComponents/namesAddressContactnoForm.component';
import NamesRemarksForm from './formsComponents/namesRemarksForm.component';
import CustomerContactForm from './formsComponents/customerContactForm.component';
//const moment = require('moment');

export class EcommProductDetailsFormView extends React.PureComponent<IEcommProductDetailsFormViewProps> {
    public state: any = {
        customerTotalPrice: 0,
        customerPrices: [0],
        customerEvents: [''],
        customerEventIDs: [''],
        categories: [''],
        customerNames: [''],
        customerRemarks: [''],
        customerMessages: [''],
        customerEmail: [''],
        customerSerialIDs: [''],
        customerSerialNumbers: [''],
        customerSerialNames: [''],
        dedicatedBy: [''],
        collectionOptions: [''],
        buildingNames: [''],
        unitNumbers: [''],
        postalCodes: [''],
        phoneNumbers: [''],
        birthDates: [''],
        birthTimes: [''],
        schoolNames: [''],
        blessingOptions: [''],
        lightOptions: [''],
        validFroms: [''],
        validTos: [''],
        quantities: [1],
        subProductQuantity: [0],
        dedicationPeriods: [''],
        countries: [''],
        companyNames: [''],
        deceasedRelationships: [''],
        surgeryDates: [''],
        deathDates: [''],
        deathTimes: [''],
        oldNames: [''],
        nameChanges: [''],
        hasTaxDeductions: [false],
        nrics: [''],
        startDates: [''],
        genders: [''],
        formsValidated: false,
        eventsSelected: false,
        namesEntered: false,
        chineseNamesEntered: false,
        phoneNumbersEntered: false,
        passportNumberEntered: false,
        relationshipsEntered: false,
        companiesEntered: false,
        schoolsEntered: false,
        pricesEntered: false,
        addressEntered: false,
        dateEntered: false,
        passportExpiryDateEntered: false,
        passportIssueDateEntered: false,
        fileUploaded: false,
        formItems: [],
        drafts: [],
        userData: undefined,
        renewableLamps: [],
        productEvents: [],
        showPopup: false,
        addRenewLamp: false,
        hasMounted: false,
        width: 0,
        registrationClosed: false,
        itemUnavailable: false,
        //isEventProduct: false,
        eventAvailable: false,
        nextKinNames: [''],
        contactNumbers: [''],
        contactNumbersNextKins: [''],
        passportNumbers: [''],
        passportExpiryDates: [''],
        passportIssuedDates: [''],
        consents: [0],
        isInsuranceIncluded: [false],
        isInsuranceIncludedNum: [0],
        chineseName: ['']
    };

    private localeCode = this.props.context.request.locale.split('-')[0];
    private eventDateLimit = 100;
    //private eventRecords: IEvent[] = [];

    public async componentDidMount() {
        if (!this.state.hasMounted) {
            window.addEventListener('resize', this._updateDimensions);

            this._getDrafts();

            // TODO: MOVE TO CONTROLLER
            await this._getRenewableLamps();

            const {
                config,
                data: { cart, product },
                context: {
                    request: { user }
                }
            } = this.props;

            const formItemsArray = [];

            const parameters = window.location.search;
            const cartlineId = new URLSearchParams(parameters).get('cartlineId');

            //const eventProductAttr = false;

            // TODO: MOVE TO CONTROLLER
            /* if (product && product.result) {
                const resultObj = await this.getProductAttributes(product.result);

                if (resultObj.eventProduct) {
                    eventProductAttr = resultObj.eventProduct;

                    await this._getEventsForProduct(product.result.RecordId);
                }
            } */

            // If: navigated to defaultpdp page from cart page to edit a cartline item.
            // Else: display past transactions made by logged in user.
            if (cartlineId && cart.result) {
                const cartLines: CartLine[] = cart.result.cart.CartLines!;

                const found = cartLines.find(cartline => cartline.LineId === cartlineId);

                const cartLineData: any[] = [];

                const getAllCartLineResult = await getAllBTGPCartLineAsync(
                    { callerContext: this.props.context.actionContext },
                    (await cart).cart.Id
                );

                if (getAllCartLineResult.length > 0) {
                    getAllCartLineResult.forEach(record => cartLineData.push(JSON.parse(record)));
                }

                const cartLineIndex = cartLineData.findIndex(cl => cl['CartLineID'] === cartlineId);

                if (found && cartLineIndex >= 0) {
                    const childCartLines = cartLineData
                        .filter(cl => cl['ParentCartLineID'] === cartlineId)
                        .sort((a, b) => (a['EventName'] > b['EventName'] ? 1 : b['EventName'] > a['EventName'] ? -1 : 0));

                    let eventNames = cartLineData[`${cartLineIndex}`]['EventName'];
                    let eventIds = cartLineData[`${cartLineIndex}`]['EventID'];
                    let quantity = found.Quantity ? found.Quantity : 1;
                    let subProductQuantity = 0;

                    childCartLines.map(child => {
                        quantity++;
                        eventNames += `;${child['EventName']}`;
                        eventIds += `;${child['EventID']}`;

                        if (child['ProductID'] !== String(found.ProductId)) {
                            const subProductfound = cartLines.find(cartline => cartline.LineId === child['CartLineID']);

                            if (subProductfound) {
                                subProductQuantity = subProductfound.Quantity!;
                            }
                        }
                    });

                    formItemsArray.push({
                        comment: found.Comment ? found.Comment : '',
                        quantity: quantity,
                        names: [
                            cartLineData[`${cartLineIndex}`]['Name_1'],
                            cartLineData[`${cartLineIndex}`]['Name_2'],
                            cartLineData[`${cartLineIndex}`]['Name_3'],
                            cartLineData[`${cartLineIndex}`]['Name_4'],
                            cartLineData[`${cartLineIndex}`]['Name_5'],
                            cartLineData[`${cartLineIndex}`]['Name_6'],
                            cartLineData[`${cartLineIndex}`]['Name_7'],
                            cartLineData[`${cartLineIndex}`]['Name_8'],
                            cartLineData[`${cartLineIndex}`]['Name_9'],
                            cartLineData[`${cartLineIndex}`]['Name_10'],
                            cartLineData[`${cartLineIndex}`]['Name_11'],
                            cartLineData[`${cartLineIndex}`]['Name_12'],
                            cartLineData[`${cartLineIndex}`]['Name_13'],
                            cartLineData[`${cartLineIndex}`]['Name_14'],
                            cartLineData[`${cartLineIndex}`]['Name_15'],
                            cartLineData[`${cartLineIndex}`]['Name_16'],
                            cartLineData[`${cartLineIndex}`]['Name_17'],
                            cartLineData[`${cartLineIndex}`]['Name_18'],
                            cartLineData[`${cartLineIndex}`]['Name_19'],
                            cartLineData[`${cartLineIndex}`]['Name_20']
                        ],
                        category: cartLineData[`${cartLineIndex}`]['Category'],
                        eventID: eventIds,
                        eventName: eventNames,
                        remarks: cartLineData[`${cartLineIndex}`]['Remarks'],
                        message: cartLineData[`${cartLineIndex}`]['Message'],
                        dedicatedBy: cartLineData[`${cartLineIndex}`]['DedicatedBy'],
                        hasTaxDeduction: cartLineData[`${cartLineIndex}`]['HasTaxDeduction'],
                        nric: cartLineData[`${cartLineIndex}`]['Nric'],
                        buildingName: cartLineData[`${cartLineIndex}`]['BuildingName'],
                        unitNumber: cartLineData[`${cartLineIndex}`]['UnitNumber'],
                        postalCode: cartLineData[`${cartLineIndex}`]['PostalCode'],
                        birthDate: cartLineData[`${cartLineIndex}`]['BirthDate'],
                        phoneNumber: cartLineData[`${cartLineIndex}`]['PhoneNumber'],
                        schoolName: cartLineData[`${cartLineIndex}`]['SchoolName'],
                        donationOption: cartLineData[`${cartLineIndex}`]['DonationOption'],
                        blessingOption: cartLineData[`${cartLineIndex}`]['BlessingOption'],
                        birthTime: cartLineData[`${cartLineIndex}`]['BirthTime'],
                        lightOption: cartLineData[`${cartLineIndex}`]['LightOption'],
                        validFrom: cartLineData[`${cartLineIndex}`]['ValidFrom'],
                        validTo: cartLineData[`${cartLineIndex}`]['ValidTo'],
                        dedicationPeriod: cartLineData[`${cartLineIndex}`]['DedicationPeriod'],
                        startDate: cartLineData[`${cartLineIndex}`]['StartDate'],
                        gender: cartLineData[`${cartLineIndex}`]['Gender'],
                        country: cartLineData[`${cartLineIndex}`]['Country'],
                        companyName: cartLineData[`${cartLineIndex}`]['CompanyName'],
                        deceasedRelationship: cartLineData[`${cartLineIndex}`]['DeceasedRelationship'],
                        surgeryDate: cartLineData[`${cartLineIndex}`]['SurgeryDate'],
                        deathDate: cartLineData[`${cartLineIndex}`]['DeathDate'],
                        deathTime: cartLineData[`${cartLineIndex}`]['DeathTime'],
                        nameChange: cartLineData[`${cartLineIndex}`]['NameChange'],
                        oldName_1: cartLineData[`${cartLineIndex}`]['OldName_1'],
                        oldName_2: cartLineData[`${cartLineIndex}`]['OldName_2'],
                        birthDate_2: cartLineData[`${cartLineIndex}`]['BirthDate_2'],
                        birthTime_2: cartLineData[`${cartLineIndex}`]['BirthTime_2'],
                        isCustomPrice: found.IsPriceKeyedIn ? found.IsPriceKeyedIn : false,
                        customPriceAmount: found.Price ? found.Price : 0,
                        cartLineId: found.LineId,
                        subProductQuantity: subProductQuantity,
                        isPastTransaction: false,
                        chineseName: cartLineData[`${cartLineIndex}`]['ChineseName'],
                        contactNumber: cartLineData[`${cartLineIndex}`]['ContactNumber'],
                        nameNextKin: cartLineData[`${cartLineIndex}`]['NameNextKin'],
                        contactNumberNextKin: cartLineData[`${cartLineIndex}`]['ContactNumberNextKin'],
                        passportNumber: cartLineData[`${cartLineIndex}`]['PassportNumber'],
                        passportExpiryDate: cartLineData[`${cartLineIndex}`]['PassportExpiryDate'],
                        passportIssuedDate: cartLineData[`${cartLineIndex}`]['PassportIssuedDate'],
                        consent: cartLineData[`${cartLineIndex}`]['Consent'],
                        isInsuranceIncluded: cartLineData[`${cartLineIndex}`]['IsInsuranceIncluded']
                    });

                    this.setState({ isEditMode: true });
                } else {
                    this.setState({ isEditMode: false });
                }
            } else if (parameters === '') {
                // Retrieve form inputs if user is logged in.
                const {
                    context,
                    context: {
                        request: { user }
                    }
                } = this.props;

                if (user.customerAccountNumber) {
                    let itemInCart = false;

                    if (cart.result && product.result) {
                        const cartLines: CartLine[] = cart.result.cart.CartLines!;
                        const foundInCart = cartLines.find(cartline => cartline.ProductId === product.result!.RecordId);

                        if (foundInCart) {
                            itemInCart = true;
                        }
                    }

                    if (!itemInCart) {
                        let lastOrderCE: any;
                        let lastOrderCommerce: any;
                        let records: string[] = [];

                        // Retrieves all extension table records of this product.
                        if (product.result) {
                            records = await getByCustomerBTGPTransactionAsync(
                                { callerContext: context.actionContext },
                                user.customerAccountNumber,
                                user.emailAddress!,
                                product.result.RecordId.toString(),
                                this.props.config.isUat
                            );

                            if (records.length > 0) {
                                // Filters for records from CE.
                                const recordsCE = records.filter(record => {
                                    const input = JSON.parse(record);

                                    return input['FromCE'] === true;
                                });

                                // Gets the most recent order from CE of this product.
                                lastOrderCE = recordsCE && recordsCE.length > 0 ? JSON.parse(recordsCE[0]) : undefined;
                            }
                        }

                        const orders = await getOrderHistoryAsync({ callerContext: context.actionContext }, user.customerAccountNumber);

                        // Finds the most recent order from Commerce that contains this product.
                        if (orders && orders.length > 0) {
                            lastOrderCommerce = orders.find((order: SalesOrder) => {
                                const found = records.find(record => {
                                    const inputs = JSON.parse(record);

                                    return inputs['SalesOrderID'] === order.Id && inputs['FromCE'] === false ? order.Id : '';
                                });

                                return found && found !== '' ? order : undefined;
                            });
                        }

                        let mostRecentOrderID = '';

                        if (lastOrderCE && lastOrderCommerce) {
                            mostRecentOrderID = moment(lastOrderCE['DateOfTrasaction']).isBefore(moment(lastOrderCommerce.CreatedDateTime))
                                ? lastOrderCommerce.Id
                                : lastOrderCE['SalesOrderID'];
                        } else if (lastOrderCE === undefined && lastOrderCommerce) {
                            mostRecentOrderID = lastOrderCommerce.Id;
                        } else if (lastOrderCE && lastOrderCommerce === undefined) {
                            mostRecentOrderID = lastOrderCE['SalesOrderID'];
                        }

                        if (mostRecentOrderID !== '') {
                            const batch = records.filter(record => {
                                const inputs = JSON.parse(record);

                                return inputs['SalesOrderID'] === mostRecentOrderID;
                            });

                            // const items: any[] = [];

                            // batch.forEach(item => items.push(JSON.parse(item)));

                            // items.sort((a, b) => {
                            //   const x = a.Name_1 as string;
                            //   const y = b.Name_1 as string;

                            //   return (x > y) ? 1 : ((x < y) ? -1 : 0);
                            // });

                            for (let i = 0; i < batch.length; ++i) {
                                const item = JSON.parse(batch[`${i}`]);

                                // const eventName = this.eventRecords.length > 0 && this.eventRecords[0] !== undefined ? this.eventRecords[0].name : '';
                                // const eventId = this.eventRecords.length > 0 && this.eventRecords[0] !== undefined ? this.eventRecords[0].id : '';
                                const eventName = '';
                                const eventId = '';

                                // const selections = items.filter(record => {
                                //   if (item['EventID'] !== record['EventID'] && item['Name_1'] === record['Name_1']) {
                                //     return record;
                                //   }
                                // });

                                // for (let j = 0; j < selections.length; ++j) {
                                //   eventName += ';' + selections[`${j}`]['EventName'];
                                //   eventId += ';' + selections[`${j}`]['EventID'];
                                // }

                                // i += selections.length;

                                formItemsArray.push({
                                    comment: '',
                                    quantity: item['Quantity'] ? item['Quantity'] : 1,
                                    names: [
                                        item['Name_1'],
                                        item['Name_2'],
                                        item['Name_3'],
                                        item['Name_4'],
                                        item['Name_5'],
                                        item['Name_6'],
                                        item['Name_7'],
                                        item['Name_8'],
                                        item['Name_9'],
                                        item['Name_10'],
                                        item['Name_11'],
                                        item['Name_12'],
                                        item['Name_13'],
                                        item['Name_14'],
                                        item['Name_15'],
                                        item['Name_16'],
                                        item['Name_17'],
                                        item['Name_18'],
                                        item['Name_19'],
                                        item['Name_20']
                                    ],
                                    category: item['Category'],
                                    eventID: eventId,
                                    eventName: eventName,
                                    remarks: item['Remarks'],
                                    message: item['Message'],
                                    dedicatedBy: item['DedicatedBy'],
                                    hasTaxDeduction: item['HasTaxDeduction'],
                                    nric: item['Nric'],
                                    buildingName: item['BuildingName'],
                                    unitNumber: item['UnitNumber'],
                                    postalCode: item['PostalCode'],
                                    birthDate: item['BirthDate'],
                                    phoneNumber: item['PhoneNumber'],
                                    schoolName: item['SchoolName'],
                                    donationOption: item['DonationOption'],
                                    blessingOption: item['BlessingOption'],
                                    birthTime: item['BirthTime'],
                                    lightOption: item['LightOption'],
                                    validFrom: item['ValidFrom'],
                                    validTo: item['ValidTo'],
                                    dedicationPeriod: item['DedicationPeriod'],
                                    startDate: item['StartDate'],
                                    gender: item['Gender'],
                                    country: item['Country'],
                                    companyName: item['CompanyName'],
                                    deceasedRelationship: item['DeceasedRelationship'],
                                    surgeryDate: item['SurgeryDate'],
                                    deathDate: item['DeathDate'],
                                    deathTime: item['DeathTime'],
                                    nameChange: item['NameChange'],
                                    oldName_1: item['OldName_1'],
                                    oldName_2: item['OldName_2'],
                                    birthDate_2: item['BirthDate_2'],
                                    birthTime_2: item['BirthTime_2'],
                                    isCustomPrice: false,
                                    customPriceAmount: 0,
                                    cartLineId: '',
                                    isPastTransaction: true,
                                    chineseName: item['ChineseName'],
                                    contactNumber: item['ContactNumber'],
                                    nameNextKin: item['NameNextKin'],
                                    contactNumberNextKin: item['ContactNumberNextKin'],
                                    passportNumber: item['PassportNumber'],
                                    passportExpiryDate: item['PassportExpiryDate'],
                                    passportIssuedDate: item['PassportIssuedDate'],
                                    consent: item['Consent'],
                                    isInsuranceIncluded: item['IsInsuranceIncluded']
                                });
                            }
                        }
                    }
                }
            }

            // TODO: MOVE TO CONTROLLER
            const data = user.isAuthenticated
                ? await getContactDetailsAsync(
                      { callerContext: this.props.context.actionContext },
                      user.emailAddress ? user.emailAddress : '',
                      config.isUat
                  )
                : [''];

            // TODO: MOVE TO CONTROLLER
            const parseUserData = data && data[0] && data[0] !== '' ? JSON.parse(data[0]) : undefined;
            this.setState({
                formItems: formItemsArray,
                userData: parseUserData,
                hasMounted: true,
                width: window.innerWidth
                //isEventProduct: eventProductAttr
            });
        }
    }

    public render(): JSX.Element | null {
        if (!this.state.hasMounted) {
            return null;
        }

        const {
            resources,
            config,
            context,
            productsList,
            telemetryContent,
            productPriceList,
            simpleProducts,
            productAvailabilities,
            data: { cart /*, product */ }
        } = this.props;

        let Total: number = 0;
        this.setState({ registrationClosed: this.props.registrationClosed });

        const addRow = (noOfRows: number): void => {
            this.props.addRow(noOfRows);
        };

        const replaceRow = (noOfRows: number, idx: number[]): void => {
            this.props.replaceRow(noOfRows, idx);
        };

        const deleteRow = (idx: number): void => {
            this.props.removeRow(idx);
        };

        const itemAddedToCart = (): void => {
            _navigateToCart();
        };

        const _navigateToCart = () => {
            const cartAliasUrl = getUrlSync('cart', this.props.context.actionContext) || '';

            if (cartAliasUrl) {
                window.location.assign(cartAliasUrl);
            }
        };

        if (this.props.rowsData.length && this.props.selectedProduct.result && this.props.selectedProduct.result.Price) {
            const quantitiesArray = this.state.quantities;
            const subProductQuantityArray = this.state.subProductQuantity;

            for (let i = 0; i < this.props.rowsData.length; i++) {
                Total +=
                    this.props.selectedProduct.result.Price *
                        (typeof quantitiesArray[`${i}`] !== 'undefined' ? quantitiesArray[`${i}`] : 1) +
                    (this.props.subProduct
                        ? this.props.subProduct.Price *
                          (typeof subProductQuantityArray[`${i}`] !== 'undefined' ? subProductQuantityArray[`${i}`] : 0)
                        : 0);
            }
        }

        let enableButton = false;

        switch (this.props.formName) {
            case 'amountDeceasedNameForm':
                enableButton = this.state.namesEntered;
                break;

            case 'categoryNamesAddressForm':
                enableButton = this.state.namesEntered && this.state.addressEntered;
                break;

            case 'categoryNamesCollectionForm':
                enableButton = this.state.namesEntered;
                break;

            case 'categoryNamesForm':
                enableButton = this.state.namesEntered;
                break;

            case 'ceremonyForm':
                enableButton = this.state.namesEntered && this.state.eventsSelected;
                break;

            case 'deceasedCategoryNamesForm':
                enableButton = this.state.namesEntered;
                break;

            case 'deceasedDedicatedByForm':
                enableButton = this.state.namesEntered;
                break;

            case 'donationForm':
                enableButton = this.state.namesEntered && this.state.pricesEntered;
                break;

            case 'coursesForm':
                enableButton = this.state.namesEntered && this.state.eventsSelected;
                break;

            case 'eventsChineseNameForm':
                enableButton = this.props.makeChineseNameMandatory
                    ? this.state.namesEntered &&
                      this.state.eventsSelected &&
                      this.state.phoneNumbersEntered &&
                      this.state.chineseNamesEntered
                    : this.state.namesEntered && this.state.eventsSelected && this.state.phoneNumbersEntered;
                break;

            case 'eventsPassportUpload':
                enableButton =
                    this.state.namesEntered &&
                    this.state.eventsSelected &&
                    this.state.phoneNumbersEntered &&
                    this.state.passportNumberEntered &&
                    this.state.dateEntered &&
                    this.state.passportExpiryDateEntered &&
                    this.state.passportIssueDateEntered &&
                    this.state.fileUploaded;
                break;
            case 'eventsPassportUploadWithInsurance':
                enableButton =
                    this.state.namesEntered &&
                    this.state.eventsSelected &&
                    this.state.phoneNumbersEntered &&
                    this.state.passportNumberEntered &&
                    this.state.dateEntered &&
                    this.state.passportExpiryDateEntered &&
                    this.state.passportIssueDateEntered &&
                    this.state.fileUploaded;
                break;

            case 'eventsNextOfKinNameForm':
                enableButton = this.state.namesEntered && this.state.eventsSelected && this.state.phoneNumbersEntered;
                break;

            case 'eventCategoryNamesForm':
                enableButton = this.state.namesEntered && this.state.eventsSelected;
                break;

            case 'eventDeceasedDedicatedByForm':
                enableButton = this.state.namesEntered && this.state.eventsSelected;
                break;

            case 'eventTaxDeductionForm':
                enableButton = this.state.formsValidated;
                break;

            case 'nameBirthDatetimeForm':
                enableButton = this.state.namesEntered;
                break;

            case 'nameBirthdaySchoolForm':
                enableButton = this.state.namesEntered && this.state.schoolsEntered && this.state.dateEntered;
                break;

            case 'namesOnlyForm':
                enableButton = this.state.namesEntered;
                break;

            case 'namesRemarksForm':
                enableButton = this.state.namesEntered;
                break;

            case 'namesAddressContactnoForm':
                enableButton = this.state.namesEntered && this.state.phoneNumbersEntered;
                break;

            case 'noOfYearsCategoryNamesForm':
                enableButton = this.state.namesEntered;
                break;

            case 'offeringForm':
                enableButton = this.state.namesEntered;
                break;

            case 'customerContactForm':
                enableButton = this.state.namesEntered;
                //enableButton = this.state.namesEntered && this.state.formsValidated;
                break;

            case 'servicesBusinessForm':
                enableButton = this.state.namesEntered && this.state.companiesEntered && this.state.addressEntered;
                break;

            case 'servicesDeceasedForm':
                enableButton =
                    this.state.namesEntered && this.state.relationshipsEntered && this.state.dateEntered && this.state.addressEntered;
                break;

            case 'servicesEducationForm':
                enableButton = this.state.namesEntered && this.state.schoolsEntered && this.state.dateEntered && this.state.addressEntered;
                break;

            case 'servicesGeneralForm':
                enableButton = this.state.namesEntered && this.state.dateEntered && this.state.addressEntered;
                break;

            case 'nameDedicationStartDateForm':
                enableButton = this.state.namesEntered && this.state.dateEntered;
                break;

            case 'servicesHealthSurgeryForm':
                enableButton = this.state.namesEntered && this.state.dateEntered && this.state.addressEntered;
                break;

            case 'servicesInfantSpiritForm':
                enableButton = this.state.namesEntered && this.state.dateEntered && this.state.addressEntered;
                break;

            case 'servicesMarriageForm':
                enableButton = this.state.namesEntered && this.state.dateEntered && this.state.addressEntered;
                break;

            case 'threeCategoryNamesForm':
                enableButton = this.state.namesEntered;
                break;

            case 'threeCategoryNamesConsecrationForm':
                enableButton = this.state.namesEntered;
                break;
        }

        const showSubDetails =
            !this.props.itemUnavailable &&
            !this.state.registrationClosed &&
            this.props.formName !== 'coursesForm' &&
            this.props.formName !== 'eventsChineseNameForm' &&
            this.props.formName !== 'eventsNextOfKinNameForm' &&
            this.props.formName !== 'eventsPassportUpload' &&
            this.props.formName !== 'eventsPassportUploadWithInsurance'
                ? true
                : this.state.renewableLamps.length > 0 && this.props.itemUnavailable && this.state.addRenewLamp
                ? true
                : this.props.formName === 'coursesForm' ||
                  this.props.formName === 'eventsChineseNameForm' ||
                  this.props.formName === 'eventsNextOfKinNameForm' ||
                  this.props.formName === 'eventsPassportUpload' ||
                  this.props.formName === 'eventsPassportUploadWithInsurance'
                ? true
                : false;

        const showNoOfYearsCategoryNamesForm =
            this.state.renewableLamps.length > 0 && this.props.itemUnavailable && this.state.addRenewLamp
                ? true
                : !this.props.itemUnavailable && !this.state.registrationClosed
                ? true
                : false;

        const showItemUnavailableNotice =
            this.props.itemUnavailable && !this.state.addRenewLamp && !this.state.registrationClosed
                ? true
                : this.state.addRenewLamp && this.state.registrationClosed
                ? true
                : false;

        const showCartAmount =
            !(this.state.itemUnavailable || this.props.itemUnavailable) &&
            !this.state.registrationClosed &&
            this.props.formName !== 'coursesForm' &&
            this.props.formName !== 'eventsChineseNameForm' &&
            this.props.formName !== 'eventsNextOfKinNameForm' &&
            this.props.formName !== 'eventsPassportUpload' &&
            this.props.formName !== 'eventsPassportUploadWithInsurance'
                ? true
                : this.props.itemUnavailable &&
                  this.state.renewableLamps.length > 0 &&
                  !this.state.registrationClosed &&
                  this.state.addRenewLamp
                ? true
                : this.props.formName === 'coursesForm' ||
                  this.props.formName === 'eventsChineseNameForm' ||
                  this.props.formName === 'eventsNextOfKinNameForm' ||
                  this.props.formName === 'eventsPassportUpload' ||
                  this.props.formName === 'eventsPassportUploadWithInsurance'
                ? true
                : false;

        /* const showSubDetails =
            !this.props.itemUnavailable && !this.state.registrationClosed
                ? true
                : this.state.renewableLamps.length > 0 && this.props.itemUnavailable && this.state.addRenewLamp
                ? true
                : false;

        const showNoOfYearsCategoryNamesForm =
            this.state.renewableLamps.length > 0 && this.props.itemUnavailable && this.state.addRenewLamp
                ? true
                : !this.props.itemUnavailable && !this.state.registrationClosed
                ? true
                : false;

        const showItemUnavailableNotice =
            this.props.itemUnavailable && !this.state.addRenewLamp && !this.state.registrationClosed
                ? true
                : this.state.addRenewLamp && this.state.registrationClosed
                ? true
                : false;

        const showCartAmount =
            !(this.state.itemUnavailable || this.props.itemUnavailable) && !this.state.registrationClosed
                ? true
                : this.props.itemUnavailable &&
                  this.state.renewableLamps.length > 0 &&
                  !this.state.registrationClosed &&
                  this.state.addRenewLamp
                ? true
                : false; */

        return (
            <div className='ecomm-purchase'>
                <div className='ecomm-purchase-header'>
                    {!(this.state.itemUnavailable || this.props.itemUnavailable) && !this.state.registrationClosed && this._renderTop()}

                    {(this.state.itemUnavailable || this.props.itemUnavailable) &&
                        this.state.renewableLamps.length > 0 &&
                        this._renderRenewableLamp()}

                    {showItemUnavailableNotice && this._renderItemUnavailableNotice()}

                    {this.state.registrationClosed && this._renderRegistrationClosedNotice()}

                    {showSubDetails && this._renderSub()}
                </div>

                {this.props.formName === 'amountDeceasedNameForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <AmountDeceasedNameForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackPrice={this._handleOnClickPrice}
                            callbackName={this._handleNameInput}
                            callbackCategory={this._handleCategoryInput}
                            callbackDedicatedBy={this._handleDedicatedByInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackPricesEntered={this._handlePricesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'categoryNamesAddressForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <CategoryNamesAddressForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackEvent={this._handleEventInput}
                            callbackEventID={this._handleEventIDInput}
                            callbackName={this._handleNameInput}
                            callbackCategory={this._handleCategoryInput}
                            callbackBuilding={this._handleBuildingNameInput}
                            callbackUnitNumber={this._handleUnitNumberInput}
                            callbackPostalCode={this._handlePostalCodeInput}
                            callbackPhoneNumber={this._handlePhoneNumberInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackAddressEntered={this._handleAddressEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            userInfo={this.state.userData}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            productEvents={this.props.eventRecords}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'categoryNamesCollectionForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <CategoryNamesCollectionForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackEvent={this._handleEventInput}
                            callbackEventID={this._handleEventIDInput}
                            callbackName={this._handleNameInput}
                            callbackCategory={this._handleCategoryInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackCollection={this._handleCollectionOptionInput}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            productEvents={this.props.eventRecords}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'categoryNamesForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <CategoryNamesForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackEvent={this._handleEventInput}
                            callbackEventID={this._handleEventIDInput}
                            callbackName={this._handleNameInput}
                            callbackCategory={this._handleCategoryInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            productEvents={this.props.eventRecords}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'ceremonyForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <CeremonyForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackEvent={this._handleEventInput}
                            callbackEventID={this._handleEventIDInput}
                            callbackName={this._handleNameInput}
                            callbackEventsSelected={this._handleEventsSelected}
                            callbackNamesEntered={this._handleNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            productEvents={this.props.eventRecords}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'deceasedCategoryNamesForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <DeceasedCategoryNamesForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackName={this._handleNameInput}
                            callbackCategory={this._handleCategoryInput}
                            callbackDedicatedBy={this._handleDedicatedByInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'deceasedDedicatedByForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <DeceasedDedicatedByForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackEvent={this._handleEventInput}
                            callbackEventID={this._handleEventIDInput}
                            callbackName={this._handleNameInput}
                            callbackDedicatedBy={this._handleDedicatedByInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            productEvents={this.props.eventRecords}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'donationForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <DonationForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackPrice={this._handleOnClickPrice}
                            callbackName={this._handleNameInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackPricesEntered={this._handlePricesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'coursesForm' &&
                    this.props.eventAvailable &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed &&
                    this.state.userData && (
                        <CoursesForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackPrice={this._handleOnClickPrice}
                            callbackName={this._handleNameInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackPricesEntered={this._handlePricesEntered}
                            callbackEventID={this._handleEventIDInput}
                            callbackEvent={this._handleEventInput}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackEventsSelected={this._handleEventsSelected}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            userInfo={this.state.userData}
                            productEvents={this.props.eventRecords}
                        />
                    )}
                {this.props.formName === 'coursesForm' &&
                    !this.state.userData &&
                    this.props.eventAvailable &&
                    this._renderCoursesItemUnavailableNotice()}
                {this.props.formName === 'coursesForm' &&
                    !this.props.eventAvailable &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed &&
                    this._renderItemUnavailableNotice()}

                {this.props.formName === 'eventsChineseNameForm' &&
                    this.props.eventAvailable &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed &&
                    this.state.userData && (
                        <EventChineseNameForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackPrice={this._handleOnClickPrice}
                            callbackName={this._handleNameInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackPricesEntered={this._handlePricesEntered}
                            callbackEventID={this._handleEventIDInput}
                            callbackEvent={this._handleEventInput}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackEventsSelected={this._handleEventsSelected}
                            callbackPhoneNumber={this._handlePhoneNumberInput}
                            callbackChineseName={this._handleChineseNameInput}
                            callbackChineseNamesEntered={this._handleChineseNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            userInfo={this.state.userData}
                            productEvents={this.props.eventDetails}
                            callbackPhoneNumbersEntered={this._handlePhoneNumbersEntered}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                            makeChinesNameMandatory={this.props.makeChineseNameMandatory}
                        />
                    )}
                {this.props.formName === 'eventsChineseNameForm' &&
                    !this.state.userData &&
                    this.props.eventAvailable &&
                    this._renderCoursesItemUnavailableNotice()}
                {this.props.formName === 'eventsChineseNameForm' &&
                    !this.props.eventAvailable &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed &&
                    this._renderItemUnavailableNotice()}

                {this.props.formName === 'eventsNextOfKinNameForm' &&
                    this.props.eventAvailable &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed &&
                    this.state.userData && (
                        <EventNextOfKinNameForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackPrice={this._handleOnClickPrice}
                            callbackName={this._handleNameInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackPricesEntered={this._handlePricesEntered}
                            callbackEventID={this._handleEventIDInput}
                            callbackEvent={this._handleEventInput}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackEventsSelected={this._handleEventsSelected}
                            callbackPhoneNumber={this._handlePhoneNumberInput}
                            callbackNextOfKinName={this._handleNextOfKinNameInput}
                            callbackNextOfKinPhoneNumber={this._handleNextOfKinPhoneNumberInput}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            userInfo={this.state.userData}
                            productEvents={this.props.eventDetails}
                            callbackPhoneNumbersEntered={this._handlePhoneNumbersEntered}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                            insuranceAmount={this.props.insuranceAmount}
                            insuranceFeeLabel={this.props.insuranceFeeLabel}
                            callbackInsuranceIncluded={this._handleIsInsuranceIncludedInput}
                            callbackInsuranceIncludedNum={this._handleIsInsuranceIncludedNumInput}
                        />
                    )}

                {this.props.formName === 'eventsNextOfKinNameForm' &&
                    !this.state.userData &&
                    this.props.eventAvailable &&
                    this._renderCoursesItemUnavailableNotice()}
                {this.props.formName === 'eventsNextOfKinNameForm' &&
                    !this.props.eventAvailable &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed &&
                    this._renderItemUnavailableNotice()}

                {this.props.formName === 'eventsPassportUpload' &&
                    this.props.eventAvailable &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed &&
                    this.state.userData && (
                        <EventPassportUploadForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackPrice={this._handleOnClickPrice}
                            callbackName={this._handleNameInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackPricesEntered={this._handlePricesEntered}
                            callbackEventID={this._handleEventIDInput}
                            callbackEvent={this._handleEventInput}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackEventsSelected={this._handleEventsSelected}
                            callbackPhoneNumber={this._handlePhoneNumberInput}
                            callbackNextOfKinName={this._handleNextOfKinNameInput}
                            callbackNextOfKinPhoneNumber={this._handleNextOfKinPhoneNumberInput}
                            callbackBirthDate={this._handleBirthDateInput}
                            callbackPassportNumber={this._handlePassportNumberInput}
                            callbackPassportExpiryDate={this._handlePassportExpiryDateInput}
                            callbackPassportIssuedDate={this._handlePassportIssuedDateInput}
                            callbackConsent={this._handleConsentsInput}
                            callbackDateEntered={this._handleDateEntered}
                            callbackPassportExpiryDateEntered={this._handlePassportExpiryDateEntered}
                            callbackPassportIssueDateEntered={this._handlePassportIssueDateEntered}
                            callbackFileUploaded={this._handleFileUploaded}
                            callbackPassportNumberEntered={this._handlePassportNumberEntered}
                            callbackRemarks={this._handleRemarkInput}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            userInfo={this.state.userData}
                            productEvents={this.props.eventDetails}
                            isUat={this.props.config.isUat}
                            organisation={this.props.config.organisation!}
                            azureContainerName={this.props.config.azureContainerName}
                            callbackPhoneNumbersEntered={this._handlePhoneNumbersEntered}
                            isFileUploaded={this.state.fileUploaded}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                            showRemarksField={this.props.showRemarksField}
                        />
                    )}
                {this.props.formName === 'eventsPassportUpload' &&
                    !this.state.userData &&
                    this.props.eventAvailable &&
                    this._renderCoursesItemUnavailableNotice()}
                {this.props.formName === 'eventsPassportUpload' &&
                    !this.props.eventAvailable &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed &&
                    this._renderItemUnavailableNotice()}

                {this.props.formName === 'eventsPassportUploadWithInsurance' &&
                    this.props.eventAvailable &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed &&
                    this.state.userData && (
                        <EventPassportUploadInsuranceForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackPrice={this._handleOnClickPrice}
                            callbackName={this._handleNameInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackPricesEntered={this._handlePricesEntered}
                            callbackEventID={this._handleEventIDInput}
                            callbackEvent={this._handleEventInput}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackEventsSelected={this._handleEventsSelected}
                            callbackPhoneNumber={this._handlePhoneNumberInput}
                            callbackNextOfKinName={this._handleNextOfKinNameInput}
                            callbackNextOfKinPhoneNumber={this._handleNextOfKinPhoneNumberInput}
                            callbackBirthDate={this._handleBirthDateInput}
                            callbackPassportNumber={this._handlePassportNumberInput}
                            callbackPassportExpiryDate={this._handlePassportExpiryDateInput}
                            callbackPassportIssuedDate={this._handlePassportIssuedDateInput}
                            callbackConsent={this._handleConsentsInput}
                            callbackDateEntered={this._handleDateEntered}
                            callbackPassportExpiryDateEntered={this._handlePassportExpiryDateEntered}
                            callbackPassportIssueDateEntered={this._handlePassportIssueDateEntered}
                            callbackFileUploaded={this._handleFileUploaded}
                            callbackPassportNumberEntered={this._handlePassportNumberEntered}
                            callbackRemarks={this._handleRemarkInput}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            userInfo={this.state.userData}
                            productEvents={this.props.eventDetails}
                            isUat={this.props.config.isUat}
                            organisation={this.props.config.organisation!}
                            azureContainerName={this.props.config.azureContainerName}
                            callbackPhoneNumbersEntered={this._handlePhoneNumbersEntered}
                            isFileUploaded={this.state.fileUploaded}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                            showRemarksField={this.props.showRemarksField}
                            insuranceAmount={this.props.insuranceAmount}
                            callbackInsuranceIncluded={this._handleIsInsuranceIncludedInput}
                            callbackInsuranceIncludedNum={this._handleIsInsuranceIncludedNumInput}
                        />
                    )}
                {this.props.formName === 'eventsPassportUploadWithInsurance' &&
                    !this.state.userData &&
                    this.props.eventAvailable &&
                    this._renderCoursesItemUnavailableNotice()}
                {this.props.formName === 'eventsPassportUploadWithInsurance' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed &&
                    this._renderItemUnavailableNotice()}

                {this.props.formName === 'eventCategoryNamesForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <EventCategoryNamesForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackEvent={this._handleEventInput}
                            callbackEventID={this._handleEventIDInput}
                            callbackName={this._handleNameInput}
                            callbackCategory={this._handleCategoryInput}
                            callbackEventsSelected={this._handleEventsSelected}
                            callbackNamesEntered={this._handleNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            productEvents={this.props.eventRecords}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'eventDeceasedDedicatedByForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <EventDeceasedDedicatedByForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackEvent={this._handleEventInput}
                            callbackEventID={this._handleEventIDInput}
                            callbackName={this._handleNameInput}
                            callbackDedicatedBy={this._handleDedicatedByInput}
                            callbackEventsSelected={this._handleEventsSelected}
                            callbackNamesEntered={this._handleNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            productEvents={this.props.eventRecords}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'eventTaxDeductionForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <EventTaxDeductionForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackEvent={this._handleEventInput}
                            callbackEventID={this._handleEventIDInput}
                            callbackName={this._handleNameInput}
                            callbackHasTaxDeduction={this._handleTaxDeductionInput}
                            callbackNRIC={this._handleNRICInput}
                            callbackPhoneNumber={this._handlePhoneNumberInput}
                            callbackBuilding={this._handleBuildingNameInput}
                            callbackUnitNumber={this._handleUnitNumberInput}
                            callbackPostalCode={this._handlePostalCodeInput}
                            callbackCountry={this._handleCountryInput}
                            callbackEnableSaveDraft={this._handleNamesEntered}
                            callbackFormsValidation={this._handleFormsValidation}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            productEvents={this.props.eventRecords}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'nameBirthDatetimeForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <NameBirthDatetimeForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackName={this._handleNameInput}
                            callbackBirthDate={this._handleBirthDateInput}
                            callbackBirthTime={this._handleBirthTimeInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackDateEntered={this._handleDateEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'nameBirthdaySchoolForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <NameBirthdaySchoolForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackEvent={this._handleEventInput}
                            callbackEventID={this._handleEventIDInput}
                            callbackName={this._handleNameInput}
                            callbackBirthDate={this._handleBirthDateInput}
                            callbackSchoolName={this._handleSchoolNameInput}
                            callbackBlessingOption={this._handleBlessingOptionInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackSchoolsEntered={this._handleSchoolsEntered}
                            callbackDateEntered={this._handleDateEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            productEvents={this.props.eventRecords}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'namesOnlyForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <NamesOnlyForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackEvent={this._handleEventInput}
                            callbackEventID={this._handleEventIDInput}
                            callbackName={this._handleNameInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            productEvents={this.props.eventRecords}
                            // productEvents={this.state.productEvents}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'namesRemarksForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <NamesRemarksForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackEvent={this._handleEventInput}
                            callbackEventID={this._handleEventIDInput}
                            callbackName={this._handleNameInput}
                            callbackRemarks={this._handleRemarkInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            productEvents={this.props.eventRecords}
                            // productEvents={this.state.productEvents}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                            showRemarksField={this.props.showRemarksField}
                        />
                    )}

                {this.props.formName === 'namesAddressContactnoForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <NamesAddressContactnoForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackEvent={this._handleEventInput}
                            callbackEventID={this._handleEventIDInput}
                            callbackName={this._handleNameInput}
                            callbackBuilding={this._handleBuildingNameInput}
                            callbackUnitNumber={this._handleUnitNumberInput}
                            callbackPostalCode={this._handlePostalCodeInput}
                            callbackCountry={this._handleCountryInput}
                            callbackPhoneNumber={this._handlePhoneNumberInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackAddressEntered={this._handleAddressEntered}
                            callbackPhoneNumbersEntered={this._handlePhoneNumbersEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            userInfo={this.state.userData}
                            isMobile={isMobile(this.state.width)}
                            productEvents={this.props.eventRecords}
                            // productEvents={this.state.productEvents}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}

                {/* SERIAL NAME */}
                {this.props.formName === 'noOfYearsCategoryNamesForm' && showNoOfYearsCategoryNamesForm && (
                    <NoOfYearsCategoryNamesForm
                        formScheme={this.props.formScheme}
                        selectedProduct={this.props.selectedProduct}
                        renewableLamps={this.state.renewableLamps}
                        rowsData={this.props.rowsData}
                        addRow={addRow}
                        replaceRow={replaceRow}
                        deleteRow={deleteRow}
                        removeLamp={this._handleRenewableLampRemove}
                        callbackName={this._handleNameInput}
                        callbackCategory={this._handleCategoryInput}
                        callbackNoOfYear={this._handleQuantitiesInput}
                        callbackLightOption={this._handleLightOptionInput}
                        callbackValidFrom={this._handleValidFromInput}
                        callbackValidTo={this._handleValidToInput}
                        callbackOldName={this._handleOldNameInput}
                        callbackNameChange={this._handleNameChangeInput}
                        callbackSerialNumber={this._handleSerialNumberInput}
                        callbackSerialId={this._handleSerialIdInput}
                        callbackSerialNames={this._handleSerialNamesInput}
                        callbackNamesEntered={this._handleNamesEntered}
                        formItems={this.state.formItems}
                        config={this.props.config}
                        localeCode={this.localeCode}
                        actionContext={this.props.context.actionContext}
                        isMobile={isMobile(this.state.width)}
                        isEditMode={this.props.isEditMode}
                        addRenewLamp={this.state.addRenewLamp}
                        itemUnavailable={this.props.itemUnavailable}
                        allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                    />
                )}
                {this.props.formName === 'offeringForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <OfferingForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackName={this._handleNameInput}
                            callbackMessage={this._handleMessageInput}
                            callbackRemarks={this._handleRemarkInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                            showRemarksField={this.props.showRemarksField}
                        />
                    )}
                {this.props.formName === 'customerContactForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <CustomerContactForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackFormValidation={this._handleFormsValidation}
                            callbackName={this._handleNameInput}
                            callbackContact={this._handleContactInput}
                            callbackEmail={this._handleEmailInput}
                            callbackDate={this._handleDateInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                            showRemarksField={this.props.showRemarksField}
                        />
                    )}
                {this.props.formName === 'servicesBusinessForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <ServicesBusinessForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackDedicationPeriod={this._handleDedicationPeriodInput}
                            callbackName={this._handleNameInput}
                            callbackCompanyName={this._handleCompanyNameInput}
                            callbackBuilding={this._handleBuildingNameInput}
                            callbackUnitNumber={this._handleUnitNumberInput}
                            callbackPostalCode={this._handlePostalCodeInput}
                            callbackCountry={this._handleCountryInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackCompaniesEntered={this._handleCompaniesEntered}
                            callbackAddressEntered={this._handleAddressEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            userInfo={this.state.userData}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'servicesDeceasedForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <ServicesDeceasedForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackDedicationPeriod={this._handleDedicationPeriodInput}
                            callbackStartDate={this._handleStartDateInput}
                            callbackDedicatedBy={this._handleDedicatedByInput}
                            callbackRelationship={this._handleDeceasedRelationshipInput}
                            callbackName={this._handleNameInput}
                            callbackRelationshipsEntered={this._handleRelationshipsEntered}
                            callbackBirthDate={this._handleBirthDateInput}
                            callbackBirthTime={this._handleBirthTimeInput}
                            callbackDeathDate={this._handleDeathDateInput}
                            callbackDeathTime={this._handleDeathTimeInput}
                            callbackBuilding={this._handleBuildingNameInput}
                            callbackUnitNumber={this._handleUnitNumberInput}
                            callbackPostalCode={this._handlePostalCodeInput}
                            callbackCountry={this._handleCountryInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackDateEntered={this._handleDateEntered}
                            callbackAddressEntered={this._handleAddressEntered}
                            callbackRemarks={this._handleRemarkInput}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            userInfo={this.state.userData}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                            showRemarksField={this.props.showRemarksField}
                        />
                    )}
                {this.props.formName === 'servicesEducationForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <ServicesEducationForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackDedicationPeriod={this._handleDedicationPeriodInput}
                            callbackName={this._handleNameInput}
                            callbackSchoolName={this._handleSchoolNameInput}
                            callbackBirthDate={this._handleBirthDateInput}
                            callbackBirthTime={this._handleBirthTimeInput}
                            callbackBuilding={this._handleBuildingNameInput}
                            callbackUnitNumber={this._handleUnitNumberInput}
                            callbackPostalCode={this._handlePostalCodeInput}
                            callbackCountry={this._handleCountryInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackSchoolsEntered={this._handleSchoolsEntered}
                            callbackDateEntered={this._handleDateEntered}
                            callbackAddressEntered={this._handleAddressEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            userInfo={this.state.userData}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'servicesGeneralForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <ServicesGeneralForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackDedicationPeriod={this._handleDedicationPeriodInput}
                            callbackName={this._handleNameInput}
                            callbackBirthDate={this._handleBirthDateInput}
                            callbackBirthTime={this._handleBirthTimeInput}
                            callbackStartDate={this._handleStartDateInput}
                            callbackGender={this._handleGenderInput}
                            callbackBuilding={this._handleBuildingNameInput}
                            callbackUnitNumber={this._handleUnitNumberInput}
                            callbackPostalCode={this._handlePostalCodeInput}
                            callbackCountry={this._handleCountryInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackDateEntered={this._handleDateEntered}
                            callbackAddressEntered={this._handleAddressEntered}
                            callbackRemarks={this._handleRemarkInput}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            userInfo={this.state.userData}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                            showRemarksField={this.props.showRemarksField}
                        />
                    )}
                {this.props.formName === 'nameDedicationStartDateForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <NamesDedicationStartDateForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackName={this._handleNameInput}
                            callbackStartDate={this._handleStartDateInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackDateEntered={this._handleDateEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            userInfo={this.state.userData}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'servicesHealthSurgeryForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <ServicesHealthSurgeryForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackDedicationPeriod={this._handleDedicationPeriodInput}
                            callbackName={this._handleNameInput}
                            callbackSurgeryDate={this._handleSurgeryDateInput}
                            callbackBirthDate={this._handleBirthDateInput}
                            callbackBirthTime={this._handleBirthTimeInput}
                            callbackBuilding={this._handleBuildingNameInput}
                            callbackUnitNumber={this._handleUnitNumberInput}
                            callbackPostalCode={this._handlePostalCodeInput}
                            callbackCountry={this._handleCountryInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackDateEntered={this._handleDateEntered}
                            callbackAddressEntered={this._handleAddressEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            userInfo={this.state.userData}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'servicesInfantSpiritForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <ServicesInfantSpiritForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackDedicationPeriod={this._handleDedicationPeriodInput}
                            callbackBlessingType={this._handleBlessingOptionInput}
                            callbackName={this._handleNameInput}
                            callbackBirthDate={this._handleBirthDateInput}
                            callbackBirthTime={this._handleBirthTimeInput}
                            callbackBuilding={this._handleBuildingNameInput}
                            callbackUnitNumber={this._handleUnitNumberInput}
                            callbackPostalCode={this._handlePostalCodeInput}
                            callbackCountry={this._handleCountryInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackDateEntered={this._handleDateEntered}
                            callbackAddressEntered={this._handleAddressEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            userInfo={this.state.userData}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'servicesMarriageForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <ServicesMarriageForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackMultiplier={this._handleQuantitiesInput}
                            callbackDedicationPeriod={this._handleDedicationPeriodInput}
                            callbackName={this._handleNameInput}
                            callbackBirthDate={this._handleBirthDateInput}
                            callbackBirthTime={this._handleBirthTimeInput}
                            callbackBuilding={this._handleBuildingNameInput}
                            callbackUnitNumber={this._handleUnitNumberInput}
                            callbackPostalCode={this._handlePostalCodeInput}
                            callbackCountry={this._handleCountryInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            callbackDateEntered={this._handleDateEntered}
                            callbackAddressEntered={this._handleAddressEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            userInfo={this.state.userData}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'threeCategoryNamesForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <ThreeCategoryNamesForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackName={this._handleNameInput}
                            callbackCategory={this._handleCategoryInput}
                            callbackDedicatedBy={this._handleDedicatedByInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {this.props.formName === 'threeCategoryNamesConsecrationForm' &&
                    !(this.state.itemUnavailable || this.props.itemUnavailable) &&
                    !this.state.registrationClosed && (
                        <ThreeCategoryNamesConsecrationForm
                            formScheme={this.props.formScheme}
                            selectedProduct={this.props.selectedProduct}
                            subProduct={this.props.subProduct}
                            rowsData={this.props.rowsData}
                            addRow={addRow}
                            deleteRow={deleteRow}
                            callbackName={this._handleNameInput}
                            callbackCategory={this._handleCategoryInput}
                            callbackDedicatedBy={this._handleDedicatedByInput}
                            callbackSubProductQuantity={this._handleSubProductQuantityInput}
                            callbackNamesEntered={this._handleNamesEntered}
                            formItems={this.state.formItems}
                            config={this.props.config}
                            localeCode={this.localeCode}
                            actionContext={this.props.context.actionContext}
                            isMobile={isMobile(this.state.width)}
                            isEditMode={this.props.isEditMode}
                            allowMultipleRegistrations={this.props.allowMultipleRegistrations}
                        />
                    )}
                {showCartAmount && (
                    <div className='ecomm-purchase-footer'>
                        <div className='content-wrapper'>
                            <p className='total'>
                                {resource.totalTitle[this.localeCode as 'en' | 'zh']} : $
                                {Total !== 0 && !this.state.isInsuranceIncluded.includes(true) ? Total : this.state.customerTotalPrice}
                            </p>
                            {productsList && productsList.length > 0 && (
                                <ProductDetailsAddtoCartButton
                                    key={`ProductDetailsAddtoCartButton_${0}`}
                                    product={productsList[0]}
                                    simpleProductList={simpleProducts}
                                    productsAvailability={productAvailabilities}
                                    productPriceList={productPriceList}
                                    telemetryContent={telemetryContent}
                                    cart={cart.result!}
                                    resources={resources}
                                    context={context}
                                    config={config}
                                    localeCode={this.localeCode}
                                    isCustomPriceSelected={this.props.isCustomPrice}
                                    keyInPriceAmount={this.state.customerPrices}
                                    isPriceKeyedIn={this.props.isCustomPrice}
                                    cartAdded={itemAddedToCart}
                                    matchingCartItems={this.props.matchingCartItems}
                                    events={this.state.customerEvents}
                                    eventIDs={this.state.customerEventIDs}
                                    serialIds={this.state.customerSerialIDs}
                                    serialNumbers={this.state.customerSerialNumbers}
                                    serialNames={this.state.customerSerialNames}
                                    names={this.state.customerNames}
                                    dedicatedBy={this.state.dedicatedBy}
                                    hasTaxDeductions={this.state.hasTaxDeductions}
                                    nrics={this.state.nrics}
                                    categories={this.state.categories}
                                    collectionOptions={this.state.collectionOptions}
                                    buildingNames={this.state.buildingNames}
                                    unitNumbers={this.state.unitNumbers}
                                    postalCodes={this.state.postalCodes}
                                    phoneNumbers={this.state.phoneNumbers}
                                    birthDates={this.state.birthDates}
                                    birthTimes={this.state.birthTimes}
                                    schoolNames={this.state.schoolNames}
                                    blessingOptions={this.state.blessingOptions}
                                    lightOptions={this.state.lightOptions}
                                    validFroms={this.state.validFroms}
                                    validTos={this.state.validTos}
                                    messages={this.state.customerMessages}
                                    remarks={this.state.customerRemarks}
                                    dedicationPeriods={this.state.dedicationPeriods}
                                    startDates={this.state.startDates}
                                    genders={this.state.genders}
                                    countries={this.state.countries}
                                    companyNames={this.state.companyNames}
                                    deceasedRelationships={this.state.deceasedRelationships}
                                    surgeryDates={this.state.surgeryDates}
                                    deathDates={this.state.deathDates}
                                    deathTimes={this.state.deathTimes}
                                    nameChanges={this.state.nameChanges}
                                    oldNames={this.state.oldNames}
                                    quantities={this.state.quantities}
                                    subProduct={this.props.subProduct}
                                    subProductQuantities={this.state.subProductQuantity}
                                    disabled={!enableButton}
                                    isEditMode={this.props.isEditMode}
                                    nameNextKins={this.state.nextKinNames}
                                    contactNumbers={this.state.contactNumbers}
                                    contactNumbersNextKin={this.state.contactNumbersNextKins}
                                    passportNumbers={this.state.passportNumbers}
                                    passportExpiryDates={this.state.passportExpiryDates}
                                    passportIssuedDates={this.state.passportIssuedDates}
                                    consents={this.state.consents}
                                    isInsuranceIncluded={this.state.isInsuranceIncludedNum}
                                    chineseNames={this.state.chineseName}
                                />
                            )}
                        </div>
                    </div>
                )}

                <ToastContainer autoClose={5000} closeButton={false} />
            </div>
        );
    }

    public componentWillUnmount() {
        window.removeEventListener('resize', this._updateDimensions);
    }

    private _renderTop(): JSX.Element | null {
        const {
            config,
            context: {
                request: { user }
            },
            formName
        } = this.props;

        const saveDraft = this.state.namesEntered ? 'save-draft' : 'save-draft disabled';
        const retrieveDraft = this.state.drafts.length !== 0 ? 'retrieve-draft' : 'retrieve-draft disabled';
        const renewLamp = this.state.renewableLamps.length !== 0 && this.props.isEditMode !== true ? 'renew-lamp' : 'renew-lamp disabled';

        const showPrompt =
            formName === 'ceremonyForm' || formName === 'eventCategoryNamesForm' || formName === 'eventDeceasedDedicatedByForm'
                ? true
                : false;

        return (
            <div className='top row'>
                <p className='title col-sm-6' id={config.formAnchorTag ? config.formAnchorTag : ''}>
                    {resource.headerText[this.localeCode as 'en' | 'zh']}
                </p>
                <div className='account col-12 col-sm-6'>
                    {user.isAuthenticated ? (
                        <div className='draft-wrapper'>
                            <button className={saveDraft} onClick={this._saveDraft} disabled={!this.state.namesEntered}>
                                {resource.saveDraft[this.localeCode as 'en' | 'zh']}
                            </button>
                            <span>|</span>
                            <button className={retrieveDraft} onClick={this._retrieveDraft} disabled={this.state.drafts.length === 0}>
                                {resource.retrieveDraft[this.localeCode as 'en' | 'zh']}
                            </button>
                            {this.props.formName === 'noOfYearsCategoryNamesForm' && (
                                <button
                                    className={renewLamp}
                                    onClick={this._handleOnClickPopup}
                                    disabled={this.state.renewableLamps.length === 0 || this.props.isEditMode === true}
                                >
                                    {resource.noOfYearsCategoryNamesForm[this.localeCode as 'en' | 'zh'].renewLampTitle}
                                </button>
                            )}
                            {showPrompt && (
                                <div className='save-draft-prompt'>{resource.saveDraftEventDatePrompt[this.localeCode as 'en' | 'zh']}</div>
                            )}
                        </div>
                    ) : (
                        <p className='prompt'>
                            {resource.accountCheckText[this.localeCode as 'en' | 'zh']}{' '}
                            <a href={(user && user.signInUrl) || ''} className='action'>
                                {resource.signInTitle[this.localeCode as 'en' | 'zh']}
                            </a>
                        </p>
                    )}
                </div>
                <Popup
                    showPopup={this.state.showPopup}
                    locale={this.localeCode}
                    renewableLamps={this.state.renewableLamps}
                    callback={this._handleClosePopup}
                    callbackProceed={this._handleProceedPopup}
                    callbackChecked={this._handleRenewableLampChecked}
                />
            </div>
        );
    }

    private _renderRenewableLamp(): JSX.Element | null {
        const {
            config,
            context: {
                request: { user }
            },
            formName
        } = this.props;

        const renewLamp = this.state.renewableLamps.length !== 0 && this.props.isEditMode !== true ? 'renew-lamp' : 'renew-lamp disabled';

        const showPrompt =
            formName === 'ceremonyForm' || formName === 'eventCategoryNamesForm' || formName === 'eventDeceasedDedicatedByForm'
                ? true
                : false;

        return (
            <div className='top row'>
                <p className='title col-sm-6' id={config.formAnchorTag ? config.formAnchorTag : ''}>
                    {resource.headerText[this.localeCode as 'en' | 'zh']}
                </p>
                <div className='account col-12 col-sm-6'>
                    {user.isAuthenticated ? (
                        <div className='draft-wrapper'>
                            {this.props.formName === 'noOfYearsCategoryNamesForm' && (
                                <button
                                    className={renewLamp}
                                    onClick={this._handleOnClickPopup}
                                    disabled={this.state.renewableLamps.length === 0 || this.props.isEditMode === true}
                                >
                                    {resource.noOfYearsCategoryNamesForm[this.localeCode as 'en' | 'zh'].renewLampTitle}
                                </button>
                            )}
                            {showPrompt && (
                                <div className='save-draft-prompt'>{resource.saveDraftEventDatePrompt[this.localeCode as 'en' | 'zh']}</div>
                            )}
                        </div>
                    ) : (
                        <p className='prompt'>
                            {resource.accountCheckText[this.localeCode as 'en' | 'zh']}{' '}
                            <a href={(user && user.signInUrl) || ''} className='action'>
                                {resource.signInTitle[this.localeCode as 'en' | 'zh']}
                            </a>
                        </p>
                    )}
                </div>
                <Popup
                    showPopup={this.state.showPopup}
                    locale={this.localeCode}
                    renewableLamps={this.state.renewableLamps}
                    callback={this._handleClosePopup}
                    callbackProceed={this._handleProceedPopup}
                    callbackChecked={this._handleRenewableLampChecked}
                />
            </div>
        );
    }

    private _renderSub(): JSX.Element | null {
        return (
            <div className='sub row'>
                <p className='title col-sm-9'>{resource.detailsTitle[this.localeCode as 'en' | 'zh']}</p>
                {isMobile(this.state.width) ? null : (
                    <p className='subtotal col-sm-2'>{resource.subTotalTitle[this.localeCode as 'en' | 'zh']}</p>
                )}
                <div className='col-sm-1' />
            </div>
        );
    }

    private _renderItemUnavailableNotice(): JSX.Element | null {
        return (
            <div className='ecomm-purchase-header-notice'>
                <h2 className='ecomm-purchase-header-notice-title'>
                    {resource.itemUnavailableNotice[this.localeCode as 'en' | 'zh'][this.props.config.organisation!].itemUnavailableHeader}
                </h2>
                <p>{resource.itemUnavailableNotice[this.localeCode as 'en' | 'zh'][this.props.config.organisation!].messageLine1}</p>
                <br />
                <p>{resource.itemUnavailableNotice[this.localeCode as 'en' | 'zh'][this.props.config.organisation!].messageLine2}</p>
                <p>{resource.itemUnavailableNotice[this.localeCode as 'en' | 'zh'][this.props.config.organisation!].messageLine2Point1}</p>
                <p>{resource.itemUnavailableNotice[this.localeCode as 'en' | 'zh'][this.props.config.organisation!].messageLine2Point2}</p>
                <p>{resource.itemUnavailableNotice[this.localeCode as 'en' | 'zh'][this.props.config.organisation!].messageLine2Point3}</p>
            </div>
        );
    }

    private _renderCoursesItemUnavailableNotice(): JSX.Element | null {
        const locale = (this.localeCode || 'en').toLowerCase() as 'en' | 'zh';
        const org = (this.props.config.organisation || 'bt').toLowerCase() as 'bt' | 'gp';
        return (
            <div className='ecomm-purchase-header-notice'>
                <h2 className='ecomm-purchase-header-notice-title'>
                    {resource.coursesUnavailableNotice[`${locale}`][`${org}`].itemUnavailableHeader}
                </h2>
                <p>{resource.coursesUnavailableNotice[`${locale}`][`${org}`].messageLine1}</p>
                <br />
                <p>{resource.coursesUnavailableNotice[`${locale}`][`${org}`].messageLine2}</p>
                <p>{resource.coursesUnavailableNotice[`${locale}`][`${org}`].messageLine2Point1}</p>
                <p>{resource.coursesUnavailableNotice[`${locale}`][`${org}`].messageLine2Point2}</p>
                <p>{resource.coursesUnavailableNotice[`${locale}`][`${org}`].messageLine2Point3}</p>
            </div>
        );
    }

    private _renderRegistrationClosedNotice(): JSX.Element | null {
        const locale = (this.localeCode || 'en').toLowerCase() as 'en' | 'zh';
        const org = (this.props.config.organisation || 'bt').toLowerCase() as 'bt' | 'gp';
        return (
            <div className='ecomm-purchase-header-notice'>
                <h2 className='ecomm-purchase-header-notice-title'>
                    {resource.registrationClosedNotice[`${locale}`][`${org}`].registrationClosedHeader}
                </h2>
                <p>{resource.registrationClosedNotice[`${locale}`][`${org}`].messageLine1}</p>
                <br />
                <p>{resource.registrationClosedNotice[`${locale}`][`${org}`].messageLine2}</p>
                <p>{resource.registrationClosedNotice[`${locale}`][`${org}`].messageLine2Point1}</p>
                <p>{resource.registrationClosedNotice[`${locale}`][`${org}`].messageLine2Point2}</p>
                <p>{resource.registrationClosedNotice[`${locale}`][`${org}`].messageLine2Point3}</p>
            </div>
        );
    }

    private _handleOnClickPrice = (value: number[]) => {
        this.setState({
            customerPrices: value,
            customerTotalPrice: value.reduce((a, b) => this.fpFix(a + b), 0)
        });
    };

    private _handleEventInput = (value: string[]) => {
        this.setState({ customerEvents: value });
    };

    private _handleEventIDInput = (value: string[]) => {
        this.setState({ customerEventIDs: value });
    };

    private _handleCategoryInput = (value: string[]) => {
        this.setState({ categories: value });
    };

    private _handleDedicationPeriodInput = (value: string[]) => {
        this.setState({ dedicationPeriods: value });
    };

    private _handleStartDateInput = (value: string[]) => {
        this.setState({ startDates: this._toSingaporeTimeZone(value) });
    };

    private _handleGenderInput = (value: string[]) => {
        this.setState({ genders: value });
    };

    private _handleNameInput = (value: string[]) => {
        this.setState({ customerNames: value });
    };

    private _handleDedicatedByInput = (value: string[]) => {
        this.setState({ dedicatedBy: value });
    };

    private _handleSubProductQuantityInput = (value: number[]) => {
        this.setState({ subProductQuantity: value });
    };

    private _handleMessageInput = (value: string[]) => {
        this.setState({ customerMessages: value });
    };

    private _handleContactInput = (value: string[]) => {
        this.setState({ contactNumbers: value });
    };

    private _handleEmailInput = (value: string[]) => {
        this.setState({ customerRemarks: value });
    };

    private _handleDateInput = (value: string[]) => {
        this.setState({ dateEntered: value });
    };

    private _handleRemarkInput = (value: string[]) => {
        this.setState({ customerRemarks: value });
    };

    private _handleCollectionOptionInput = (value: string[]) => {
        this.setState({ collectionOptions: value });
    };

    private _handleTaxDeductionInput = (value: boolean[]) => {
        this.setState({ hasTaxDeductions: value });
    };

    private _handleNRICInput = (value: string[]) => {
        this.setState({ nrics: value });
    };

    private _handleBuildingNameInput = (value: string[]) => {
        this.setState({ buildingNames: value });
    };

    private _handleUnitNumberInput = (value: string[]) => {
        this.setState({ unitNumbers: value });
    };

    private _handlePostalCodeInput = (value: string[]) => {
        this.setState({ postalCodes: value });
    };

    private _handlePhoneNumberInput = (value: string[]) => {
        this.setState({ phoneNumbers: value });
    };

    private _handleChineseNameInput = (value: string[]) => {
        this.setState({ chineseNames: value });
    };

    private _handleNextOfKinNameInput = (value: string[]) => {
        this.setState({ nextKinNames: value });
    };

    private _handlePassportNumberInput = (value: string[]) => {
        this.setState({ passportNumbers: value });
    };

    private _handlePassportExpiryDateInput = (value: string[]) => {
        this.setState({ passportExpiryDates: value });
    };

    private _handlePassportIssuedDateInput = (value: string[]) => {
        this.setState({ passportIssuedDates: value });
    };

    private _handleConsentsInput = (value: string[]) => {
        this.setState({ consents: value });
    };

    private _handleIsInsuranceIncludedInput = (value: boolean[]) => {
        this.setState({ isInsuranceIncluded: value });
    };

    private _handleIsInsuranceIncludedNumInput = (value: number[]) => {
        this.setState({ isInsuranceIncludedNum: value });
    };

    private _handleNextOfKinPhoneNumberInput = (value: string[]) => {
        this.setState({ contactNumbersNextKins: value });
    };

    private _handleSurgeryDateInput = (value: string[]) => {
        this.setState({ surgeryDates: value });
    };

    private _handleBirthDateInput = (value: string[]) => {
        this.setState({ birthDates: this._toSingaporeTimeZone(value) });
    };

    private _handleBirthTimeInput = (value: string[]) => {
        this.setState({ birthTimes: value });
    };

    private _handleSchoolNameInput = (value: string[]) => {
        this.setState({ schoolNames: value });
    };

    private _handleBlessingOptionInput = (value: string[]) => {
        this.setState({ blessingOptions: value });
    };

    private _handleLightOptionInput = (value: string[]) => {
        this.setState({ lightOptions: value });
    };

    private _handleQuantitiesInput = (value: number[]) => {
        this.setState({ quantities: value });
    };

    private _handleValidFromInput = (value: string[]) => {
        this.setState({ validFroms: value });
    };

    private _handleValidToInput = (value: string[]) => {
        this.setState({ validTos: value });
    };

    private _handleCountryInput = (value: string[]) => {
        this.setState({ countries: value });
    };

    private _handleCompanyNameInput = (value: string[]) => {
        this.setState({ companyNames: value });
    };

    private _handleDeceasedRelationshipInput = (value: string[]) => {
        this.setState({ deceasedRelationships: value });
    };

    private _handleDeathDateInput = (value: string[]) => {
        this.setState({ deathDates: this._toSingaporeTimeZone(value) });
    };

    private _handleDeathTimeInput = (value: string[]) => {
        this.setState({ deathTimes: value });
    };

    private _handleOldNameInput = (value: string[]) => {
        this.setState({ oldNames: value });
    };

    private _handleNameChangeInput = (value: string[]) => {
        this.setState({ nameChanges: value });
    };

    private _handleSerialIdInput = (value: string[]) => {
        this.setState({ customerSerialIDs: value });
    };

    private _handleSerialNumberInput = (value: string[]) => {
        this.setState({ customerSerialNumbers: value });
    };

    private _handleSerialNamesInput = (value: string[]) => {
        this.setState({ customerSerialNames: value });
    };

    private _handleFormsValidation = (value: boolean) => {
        this.setState({ formsValidated: value });
    };

    private _handleEventsSelected = (value: boolean) => {
        this.setState({ eventsSelected: value });
    };

    private _handleNamesEntered = (value: boolean) => {
        this.setState({ namesEntered: value });
    };

    private _handleChineseNamesEntered = (value: boolean) => {
        this.setState({ chineseNamesEntered: value });
    };

    private _handlePhoneNumbersEntered = (value: boolean) => {
        this.setState({ phoneNumbersEntered: value });
    };

    private _handlePassportNumberEntered = (value: boolean) => {
        this.setState({ passportNumberEntered: value });
    };

    private _handleRelationshipsEntered = (value: boolean) => {
        this.setState({ relationshipsEntered: value });
    };

    private _handleCompaniesEntered = (value: boolean) => {
        this.setState({ companiesEntered: value });
    };

    private _handleSchoolsEntered = (value: boolean) => {
        this.setState({ schoolsEntered: value });
    };

    private _handlePricesEntered = (value: boolean) => {
        this.setState({ pricesEntered: value });
    };

    private _handleAddressEntered = (value: boolean) => {
        this.setState({ addressEntered: value });
    };

    private _handleDateEntered = (value: boolean) => {
        this.setState({ dateEntered: value });
    };

    private _handlePassportExpiryDateEntered = (value: boolean) => {
        this.setState({ passportExpiryDateEntered: value });
    };

    private _handlePassportIssueDateEntered = (value: boolean) => {
        this.setState({ passportIssueDateEntered: value });
    };

    private _handleFileUploaded = (value: boolean) => {
        this.setState({ fileUploaded: value });
    };

    private _handleRenewableLampChecked = (value: any[]) => {
        this.setState({ renewableLamps: value });
    };

    private _handleRenewableLampRemove = (value: string) => {
        const lamps: any[] = this.state.renewableLamps.slice();

        const removeLampIndex = lamps.findIndex(lamp => lamp['serialId'] === value);

        if (removeLampIndex >= 0) {
            lamps[`${removeLampIndex}`]['isChecked'] = false;
            lamps[`${removeLampIndex}`]['isAdded'] = false;

            this.setState({ renewableLamps: lamps });
        }
    };

    private _updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    };

    private fpFix(value: number) {
        return Math.round(value * 100) / 100;
    }

    private _saveDraft = () => {
        if (this.props.eventProduct) {
            this._checkRegistrationPeriod();
        }

        void this._checkAvailableSerial();

        if (this.state.namesEntered && !this.state['registrationClosed'] && !this.state['itemUnavailable']) {
            const {
                context,
                data: { accountInformation, product },
                rowsData
            } = this.props;

            const customer = accountInformation?.result;
            const nullDate = new Date(1900, 1, 1, 0, 0, 0).toISOString();

            if (this._checkUnderEventDatesLimit()) {
                for (let i = 0; i < rowsData.length; ++i) {
                    const eventNames = this.state.customerEvents[`${i}`] ? this.state.customerEvents[`${i}`] : '';
                    const eventIDs = this.state.customerEventIDs[`${i}`] ? this.state.customerEventIDs[`${i}`] : '';

                    const eventNamesArray = eventNames.split(';');
                    const eventIDsArray = eventIDs.split(';');

                    const serialId = this.state.customerSerialIDs[`${i}`] ? this.state.customerSerialIDs[`${i}`] : '';
                    const serialNumber = this.state.customerSerialNumbers[`${i}`] ? this.state.customerSerialNumbers[`${i}`] : '';
                    const serialName = this.state.customerSerialNames[`${i}`] ? this.state.customerSerialNames[`${i}`] : '';

                    const names = this.state.customerNames[`${i}`].split(';');

                    const remarks = this.state.customerRemarks[`${i}`] ? this.state.customerRemarks[`${i}`] : '';
                    const messages = this.state.customerMessages[`${i}`] ? this.state.customerMessages[`${i}`] : '';
                    //const email = this.state.customerEmail[`${i}`] ? this.state.customerEmail[`${i}`] : '';

                    const category = this.state.categories[`${i}`] ? this.state.categories[`${i}`] : '';

                    const dedicatedBy = this.state.dedicatedBy[`${i}`] ? this.state.dedicatedBy[`${i}`] : '';

                    const hasTaxDeduction = this.state.hasTaxDeductions[`${i}`] ? this.state.hasTaxDeductions[`${i}`] : false;
                    const nric = this.state.nrics[`${i}`] ? this.state.nrics[`${i}`] : '';

                    const buildingName = this.state.buildingNames[`${i}`] ? this.state.buildingNames[`${i}`] : '';
                    const unitNumber = this.state.unitNumbers[`${i}`] ? this.state.unitNumbers[`${i}`] : '';
                    const postalCode = this.state.postalCodes[`${i}`] ? this.state.postalCodes[`${i}`] : '';
                    const phoneNumber = this.state.phoneNumbers[`${i}`] ? this.state.phoneNumbers[`${i}`] : '';
                    const chineseName = this.state.chineseNames[`${i}`] ? this.state.chineseNames[`${i}`] : '';
                    const nameNextKin = this.state.nextKinNames[`${i}`] ? this.state.nextKinNames[`${i}`] : '';
                    const contactNumber = this.state.contactNumbers[`${i}`] ? this.state.contactNumbers[`${i}`] : '';
                    const contactNumberNextKin = this.state.contactNumbersNextKins[`${i}`] ? this.state.contactNumbersNextKins[`${i}`] : '';
                    const passportNumber = this.state.passportNumbers[`${i}`] ? this.state.passportNumbers[`${i}`] : '';
                    const passportExpiryDate =
                        this.state.passportExpiryDates[`${i}`] && this.state.passportExpiryDates[`${i}`] !== ''
                            ? this.state.passportExpiryDates[`${i}`]
                            : nullDate;
                    const passportIssuedDate =
                        this.state.passportIssuedDates[`${i}`] && this.state.passportIssuedDates[`${i}`] !== ''
                            ? this.state.passportIssuedDates[`${i}`]
                            : nullDate;
                    const consent = this.state.consents[`${i}`] ? this.state.consents[`${i}`] : 0;
                    const isInsuranceIncluded = this.state.isInsuranceIncludedNum[`${i}`] ? this.state.isInsuranceIncludedNum[`${i}`] : 0;
                    const country = this.state.countries[`${i}`] ? this.state.countries[`${i}`] : '';

                    const birthDates = this.state.birthDates[`${i}`] ? this.state.birthDates[`${i}`].split(';') : [];
                    const birthTimes = this.state.birthTimes[`${i}`] ? this.state.birthTimes[`${i}`].split(';') : [];

                    const schoolName = this.state.schoolNames[`${i}`] ? this.state.schoolNames[`${i}`] : '';

                    const collectionOption = this.state.collectionOptions[`${i}`] ? this.state.collectionOptions[`${i}`] : '';
                    const blessingOption = this.state.blessingOptions[`${i}`] ? this.state.blessingOptions[`${i}`] : '';
                    const lightOption = this.state.lightOptions[`${i}`] ? this.state.lightOptions[`${i}`] : '';

                    const validFrom =
                        this.state.validFroms[`${i}`] && this.state.validFroms[`${i}`] !== '' ? this.state.validFroms[`${i}`] : nullDate;
                    const validTo =
                        this.state.validTos[`${i}`] && this.state.validTos[`${i}`] !== '' ? this.state.validTos[`${i}`] : nullDate;

                    const surgeryDate =
                        this.state.surgeryDates[`${i}`] && this.state.surgeryDates[`${i}`] !== ''
                            ? this.state.surgeryDates[`${i}`]
                            : nullDate;

                    const dedicationPeriod = this.state.dedicationPeriods[`${i}`] ? this.state.dedicationPeriods[`${i}`] : '';
                    const startDate = this.state.startDates[`${i}`] ? this.state.startDates[`${i}`] : nullDate;

                    const companyName = this.state.companyNames[`${i}`] ? this.state.companyNames[`${i}`] : '';

                    const deceasedRelationship = this.state.deceasedRelationships[`${i}`] ? this.state.deceasedRelationships[`${i}`] : '';
                    const deathDate =
                        this.state.deathDates[`${i}`] && this.state.deathDates[`${i}`] !== '' ? this.state.deathDates[`${i}`] : nullDate;
                    const deathTime = this.state.deathTimes[`${i}`] ? this.state.deathTimes[`${i}`] : '';

                    const quantity = 1;

                    const nameChange = this.state.nameChanges[`${i}`] ? this.state.nameChanges[`${i}`] : '';
                    const oldNames = this.state.oldNames[`${i}`] ? this.state.oldNames[`${i}`].split(';') : [];

                    const gender = this.state.genders[`${i}`] ? this.state.genders[`${i}`] : '';

                    for (let j = 0; j < eventNamesArray.length; ++j) {
                        createOrUpdateBTGPDraftAsync(
                            { callerContext: context.actionContext },
                            uuidv4(),
                            customer?.AccountNumber!,
                            product.result?.RecordId.toString()!,
                            eventIDsArray[`${j}`],
                            eventNamesArray[`${j}`],
                            serialId,
                            serialNumber,
                            serialName,
                            names[0] ? names[0] : '',
                            names[1] ? names[1] : '',
                            names[2] ? names[2] : '',
                            names[3] ? names[3] : '',
                            names[4] ? names[4] : '',
                            names[5] ? names[5] : '',
                            names[6] ? names[6] : '',
                            names[7] ? names[7] : '',
                            names[8] ? names[8] : '',
                            names[9] ? names[9] : '',
                            names[10] ? names[10] : '',
                            names[11] ? names[11] : '',
                            names[12] ? names[12] : '',
                            names[13] ? names[13] : '',
                            names[14] ? names[14] : '',
                            names[15] ? names[15] : '',
                            names[16] ? names[16] : '',
                            names[17] ? names[17] : '',
                            names[18] ? names[18] : '',
                            names[19] ? names[19] : '',
                            remarks,
                            messages,
                            category,
                            dedicatedBy,
                            hasTaxDeduction,
                            nric,
                            buildingName,
                            unitNumber,
                            postalCode,
                            birthDates[0] ? birthDates[0] : nullDate,
                            phoneNumber,
                            schoolName,
                            collectionOption,
                            blessingOption,
                            '1',
                            new Date().toISOString(),
                            birthTimes[0] ? birthTimes[0] : '',
                            lightOption,
                            validFrom,
                            validTo,
                            rowsData[`${i}`].id,
                            dedicationPeriod,
                            country,
                            companyName,
                            deceasedRelationship,
                            surgeryDate,
                            deathDate,
                            deathTime,
                            quantity,
                            nameChange,
                            oldNames[0] ? oldNames[0] : '',
                            oldNames[1] ? oldNames[1] : '',
                            birthDates[1] ? birthDates[1] : '',
                            birthTimes[1] ? birthTimes[1] : '',
                            startDate,
                            gender,
                            chineseName,
                            contactNumber,
                            nameNextKin,
                            contactNumberNextKin,
                            passportNumber,
                            passportExpiryDate,
                            passportIssuedDate,
                            consent,
                            isInsuranceIncluded
                        )
                            .then(result => {
                                if (result) {
                                    if (j === eventNamesArray.length - 1) {
                                        this._getDrafts();

                                        toast.success(resource.saveDraftSuccessMsg[this.localeCode as 'en' | 'zh']);
                                    }
                                }
                            })
                            .catch(error => {
                                const extra = `Customer: ${customer?.AccountNumber!}`;

                                const item: FormDetails = {
                                    CartLineID: '',
                                    CartID: '',
                                    CartLineComment: '',
                                    ParentCartLineID: rowsData[`${i}`].id,
                                    ProductID: product.result?.RecordId.toString()!,
                                    EventID: eventIDsArray[`${j}`],
                                    EventName: eventNamesArray[`${j}`],
                                    SerialID: serialId,
                                    SerialNumber: serialNumber,
                                    SerialName: serialName,
                                    Name_1: names[0] ? names[0] : '',
                                    Name_2: names[1] ? names[1] : '',
                                    Name_3: names[2] ? names[2] : '',
                                    Name_4: names[3] ? names[3] : '',
                                    Name_5: names[4] ? names[4] : '',
                                    Name_6: names[5] ? names[5] : '',
                                    Name_7: names[6] ? names[6] : '',
                                    Name_8: names[7] ? names[7] : '',
                                    Name_9: names[8] ? names[8] : '',
                                    Name_10: names[9] ? names[9] : '',
                                    Name_11: names[10] ? names[10] : '',
                                    Name_12: names[11] ? names[11] : '',
                                    Name_13: names[12] ? names[12] : '',
                                    Name_14: names[13] ? names[13] : '',
                                    Name_15: names[14] ? names[14] : '',
                                    Name_16: names[15] ? names[15] : '',
                                    Name_17: names[16] ? names[16] : '',
                                    Name_18: names[17] ? names[17] : '',
                                    Name_19: names[18] ? names[18] : '',
                                    Name_20: names[19] ? names[19] : '',
                                    Remarks: remarks,
                                    Message: messages,
                                    Category: category,
                                    DedicatedBy: dedicatedBy,
                                    HasTaxDeduction: hasTaxDeduction,
                                    Nric: nric,
                                    BuildingName: buildingName,
                                    UnitNumber: unitNumber,
                                    PostalCode: postalCode,
                                    PhoneNumber: phoneNumber,
                                    ChineseName: chineseName,
                                    Country: country,
                                    SchoolName: schoolName,
                                    CompanyName: companyName,
                                    DonationOption: collectionOption,
                                    BlessingOption: blessingOption,
                                    LightOption: lightOption,
                                    ValidFrom: validFrom,
                                    ValidTo: validTo,
                                    DedicationPeriod: dedicationPeriod,
                                    StartDate: startDate,
                                    Gender: gender,
                                    SurgeryDate: surgeryDate,
                                    BirthDate: birthDates[0] ? birthDates[0] : nullDate,
                                    BirthTime: birthTimes[0] ? birthTimes[0] : '',
                                    BirthDate_2: birthDates[1] ? birthDates[1] : '',
                                    BirthTime_2: birthTimes[1] ? birthTimes[1] : '',
                                    DeathDate: deathDate,
                                    DeathTime: deathTime,
                                    DeceasedRelationship: deceasedRelationship,
                                    NameChange: nameChange,
                                    OldName_1: oldNames[0] ? oldNames[0] : '',
                                    OldName_2: oldNames[1] ? oldNames[1] : '',
                                    NameNextKin: nameNextKin,
                                    ContactNumber: contactNumber,
                                    ContactNumberNextKin: contactNumberNextKin,
                                    PassportNumber: passportNumber,
                                    PassportExpiryDate: passportExpiryDate,
                                    PassportIssuedDate: passportIssuedDate,
                                    Consent: consent,
                                    IsInsuranceIncluded: isInsuranceIncluded
                                };

                                void generateErrorLog(
                                    context,
                                    'ERROR ecomm-product-detaials-form _saveDraft',
                                    `${extra} | Error: ${error}`,
                                    item
                                );

                                toast.error(resource.saveDraftErrorMsg[this.localeCode as 'en' | 'zh']);
                            });
                    }
                }
            } else {
                toast.warning(resource.saveDraftOverLimitMsg[this.localeCode as 'en' | 'zh']);
            }
        }
    };

    private _retrieveDraft = () => {
        if (this.props.eventProduct) {
            this._checkRegistrationPeriod();
        }

        void this._checkAvailableSerial();

        if (!this.state['registrationClosed'] && !this.state['itemUnavailable']) {
            this._populateFormDisplay();

            this.props.retrieveRow(this.state.drafts);

            toast.success(resource.retrieveDraft[this.localeCode as 'en' | 'zh']);
        }
    };

    private _getDrafts() {
        const {
            context,
            data: { accountInformation, product }
        } = this.props;

        const customer = accountInformation?.result;

        if (customer?.AccountNumber) {
            void getAllBTGPDraftAsync(
                { callerContext: context.actionContext },
                customer?.AccountNumber,
                product.result?.RecordId.toString()!
            ).then(result => {
                if (result.length !== 0) {
                    const latest = new Date(JSON.parse(result[0]).ModifiedDateTime);

                    const batch = result.filter(item => {
                        const draft = JSON.parse(item);
                        const date = new Date(draft.ModifiedDateTime);

                        if (
                            date.getUTCDate() === latest.getUTCDate() &&
                            date.getUTCMonth() === latest.getUTCMonth() &&
                            date.getFullYear() === latest.getUTCFullYear() &&
                            date.getUTCMinutes() === latest.getUTCMinutes() &&
                            date.getUTCHours() === latest.getUTCHours() &&
                            draft.IsValid === '1'
                        ) {
                            return draft;
                        }
                    });

                    const items: any[] = [];

                    batch.forEach(item => items.push(JSON.parse(item)));

                    items.sort((a, b) => {
                        const x = a.ParentDraftID as string;
                        const y = b.ParentDraftID as string;

                        return x > y ? 1 : x < y ? -1 : 0;
                    });

                    const inputs = [];

                    for (let i = 0; i < items.length; ++i) {
                        const input = items[`${i}`];

                        const names = [
                            input.Name_1,
                            input.Name_2,
                            input.Name_3,
                            input.Name_4,
                            input.Name_5,
                            input.Name_6,
                            input.Name_7,
                            input.Name_8,
                            input.Name_9,
                            input.Name_10,
                            input.Name_11,
                            input.Name_12,
                            input.Name_13,
                            input.Name_14,
                            input.Name_15,
                            input.Name_16,
                            input.Name_17,
                            input.Name_18,
                            input.Name_19,
                            input.Name_20
                        ];

                        const category =
                            input.Category !== '' ? input.Category : resource.categoryFamilyLabel[this.localeCode as 'en' | 'zh'];
                        const donationOption =
                            input.DonationOption !== ''
                                ? input.DonationOption
                                : resource.optionCollectionLabel[this.localeCode as 'en' | 'zh'];
                        const blessingOption =
                            input.BlessingOption !== ''
                                ? input.BlessingOption
                                : resource.optionInPersonLabel[this.localeCode as 'en' | 'zh'];

                        let eventNames = input.EventName;
                        let eventIds = input.EventID;

                        const selections = items.filter(record => {
                            if (input.DraftID !== record.DraftID && input.ParentDraftID === record.ParentDraftID) {
                                return record;
                            }
                        });

                        for (let j = 0; j < selections.length; ++j) {
                            eventNames += `;${selections[`${j}`].EventName}`;
                            eventIds += `;${selections[`${j}`].EventID}`;
                        }

                        i += selections.length;

                        const item = {
                            DraftID: input.DraftID,
                            CustomerID: input.CustomerID,
                            ProductID: input.ProductID,
                            EventID: eventIds,
                            EventName: eventNames,
                            SerialID: input.SerialID,
                            SerialNumber: input.SerialNumber,
                            SerialName: input.SerialName,
                            Names: names,
                            Remarks: input.Remarks,
                            Message: input.Message,
                            Category: category,
                            DedicatedBy: input.DedicatedBy,
                            HasTaxDeduction: input.HasTaxDeduction,
                            Nric: input.Nric,
                            BuildingName: input.BuildingName,
                            UnitNumber: input.UnitNumber,
                            PostalCode: input.PostalCode,
                            Country: input.Country,
                            BirthDate: input.BirthDate,
                            BirthDate_2: input.BirthDate_2,
                            BirthTime_2: input.BirthTime_2,
                            PhoneNumber: input.PhoneNumber,
                            SchoolName: input.SchoolName,
                            DedicationPeriod: input.DedicationPeriod,
                            DonationOption: donationOption,
                            BlessingOption: blessingOption,
                            IsValid: input.IsValid,
                            CreatedDateTime: input.CreatedDateTime,
                            ModifiedDateTime: input.ModifiedDateTime,
                            BirthTime: input.BirthTime,
                            LightOption: input.LightOption,
                            ValidFrom: input.ValidFrom,
                            ValidTo: input.ValidTo,
                            ParentDraftID: input.ParentDraftID,
                            CompanyName: input.CompanyName,
                            DeceasedRelationship: input.DeceasedRelationship,
                            SurgeryDate: input.SurgeryDate,
                            DeathDate: input.DeathDate,
                            DeathTime: input.DeathTime,
                            NameChange: input.NameChange,
                            OldName_1: input.OldName_1,
                            OldName_2: input.OldName_2,
                            Quantity: input.Quantity,
                            ChineseName: input.ChineseName,
                            ContactNumber: input.ContactNumber,
                            NameNextKin: input.NameNextKin,
                            ContactNumberNextKin: input.ContactNumberNextKin,
                            PassportNumber: input.PassportNumber,
                            PassportExpiryDate: input.PassportExpiryDate,
                            PassportIssuedDate: input.PassportIssuedDate,
                            Consent: input.Consent,
                            IsInsuranceIncluded: input.IsInsuranceIncluded
                        };

                        inputs.push(item);
                    }

                    this.setState({ drafts: inputs });
                }
            });
        }
    }

    private _populateFormDisplay() {
        const inputs = [];

        for (let i = 0; i < this.state.drafts.length; ++i) {
            const item = {
                quantity: this.state.drafts[`${i}`].Quantity,
                names: this.state.drafts[`${i}`].Names,
                category: this.state.drafts[`${i}`].Category,
                eventID: this.state.drafts[`${i}`].EventID,
                eventName: this.state.drafts[`${i}`].EventName,
                remarks: this.state.drafts[`${i}`].Remarks,
                message: this.state.drafts[`${i}`].Message,
                dedicatedBy: this.state.drafts[`${i}`].DedicatedBy,
                hasTaxDeduction: this.state.drafts[`${i}`].HasTaxDeduction,
                nric: this.state.drafts[`${i}`].Nric,
                buildingName: this.state.drafts[`${i}`].BuildingName,
                unitNumber: this.state.drafts[`${i}`].UnitNumber,
                postalCode: this.state.drafts[`${i}`].PostalCode,
                birthDate: this.state.drafts[`${i}`].BirthDate,
                phoneNumber: this.state.drafts[`${i}`].PhoneNumber,
                schoolName: this.state.drafts[`${i}`].SchoolName,
                donationOption: this.state.drafts[`${i}`].DonationOption,
                blessingOption: this.state.drafts[`${i}`].BlessingOption,
                birthTime: this.state.drafts[`${i}`].BirthTime,
                lightOption: this.state.drafts[`${i}`].LightOption,
                validFrom: this.state.drafts[`${i}`].ValidFrom,
                validTo: this.state.drafts[`${i}`].ValidTo,
                dedicationPeriod: this.state.drafts[`${i}`].DedicationPeriod,
                country: this.state.drafts[`${i}`].Country,
                companyName: this.state.drafts[`${i}`].CompanyName,
                deceasedRelationship: this.state.drafts[`${i}`].DeceasedRelationship,
                surgeryDate: this.state.drafts[`${i}`].SurgeryDate,
                deathDate: this.state.drafts[`${i}`].DeathDate,
                deathTime: this.state.drafts[`${i}`].DeathTime,
                nameChange: this.state.drafts[`${i}`].NameChange,
                oldName_1: this.state.drafts[`${i}`].OldName_1,
                oldName_2: this.state.drafts[`${i}`].OldName_2,
                birthDate_2: this.state.drafts[`${i}`].BirthDate_2,
                birthTime_2: this.state.drafts[`${i}`].BirthTime_2,
                chineseName: this.state.drafts[`${i}`].ChineseName,
                contactNumber: this.state.drafts[`${i}`].ContactNumber,
                nameNextKin: this.state.drafts[`${i}`].NameNextKin,
                contactNumberNextKin: this.state.drafts[`${i}`].ContactNumberNextKin,
                passportNumber: this.state.drafts[`${i}`].PassportNumber,
                passportExpiryDate: this.state.drafts[`${i}`].PassportExpiryDate,
                passportIssuedDate: this.state.drafts[`${i}`].PassportIssuedDate,
                consent: this.state.drafts[`${i}`].Consent,
                isInsuranceIncluded: this.state.drafts[`${i}`].IsInsuranceIncluded,
                isPastTransaction: false
            };

            inputs.push(item);
        }

        this.setState({ formItems: inputs });
    }

    private async _getRenewableLamps() {
        const {
            context,
            data: { accountInformation, product, cart }
        } = this.props;

        const customer = accountInformation?.result;

        if (customer?.Email) {
            const cartLineData: any[] = [];

            const getAllCartLineResult = await getAllBTGPCartLineAsync(
                { callerContext: this.props.context.actionContext },
                (await cart).cart.Id
            );

            if (getAllCartLineResult.length > 0) {
                getAllCartLineResult.map(record => {
                    cartLineData.push(JSON.parse(record));
                });
            }

            const getRenewableSerialResult = await getRenewableSerialsAsync(
                { callerContext: context.actionContext },
                this.props.config.isUat,
                product.result?.RecordId.toString()!,
                customer?.Email
            );

            if (getRenewableSerialResult.length !== 0) {
                const inputs = [];

                for (let i = 0; i < getRenewableSerialResult.length; ++i) {
                    const input = JSON.parse(getRenewableSerialResult[`${i}`]);

                    const cartLine = cartLineData.find(cl => cl['SerialID'] === input.gmb_serialnumberid);

                    const item = {
                        name_1: input.gmb_displayname1,
                        name_2: input.gmb_displayname2,
                        category: input.gmb_category,
                        validTo: input.gmb_lightvalidto,
                        serialNumber: input.gmb_serialnumber,
                        serialId: input.gmb_serialnumberid,
                        serialName: input.gmb_name,
                        isChecked: cartLine ? true : false,
                        isAdded: cartLine ? true : false
                    };

                    inputs.push(item);
                }

                this.setState({ renewableLamps: inputs });
            }
        }
    }
    /* private async getProductAttributes(product: SimpleProduct): Promise<Attributes> {
        const { context } = this.props;

        const attributesList = await getAttributeValuesAsync(
            { callerContext: context.actionContext },
            product.RecordId,
            context.request.apiSettings.channelId,
            context.request.apiSettings.catalogId
        );

        let formName = '';
        let amountArray: string[] = [];
        let names: number = 1;
        let companyNames: number = 1;
        let deceasedNames: number = 1;
        let subProductRecordId: number = 0;
        let hasSerial: boolean = false;
        let eventProduct: boolean = true;

        for (let i = 0; i < attributesList.length; i++) {
            if (attributesList[`${i}`].Name?.includes('Form')) {
                formName = attributesList[`${i}`].TextValue ? attributesList[`${i}`].TextValue! : 'Offering';
            } else if (attributesList[`${i}`].Name?.includes('Amount')) {
                const amount = attributesList[`${i}`].TextValue ? attributesList[`${i}`].TextValue! : '2,5,10,50';

                amountArray = amount.split(',');
                amountArray.push(resource.otherLabel[this.localeCode as 'en' | 'zh']);
            } else if (attributesList[`${i}`].Name?.includes('No Of Names')) {
                names = attributesList[`${i}`].IntegerValue ? attributesList[`${i}`].IntegerValue! : 1;
            } else if (attributesList[`${i}`].Name?.includes('Company Names')) {
                companyNames = attributesList[`${i}`].IntegerValue ? attributesList[`${i}`].IntegerValue! : 1;
            } else if (attributesList[`${i}`].Name?.includes('Deceased Names')) {
                deceasedNames = attributesList[`${i}`].IntegerValue ? attributesList[`${i}`].IntegerValue! : 1;
            } else if (attributesList[`${i}`].Name?.includes('Sub Product Record ID')) {
                subProductRecordId = attributesList[`${i}`].TextValue ? +attributesList[`${i}`].TextValue! : 0;
            } else if (attributesList[`${i}`].Name?.includes('Has Serial')) {
                hasSerial = attributesList[`${i}`].BooleanValue ? attributesList[`${i}`].BooleanValue! : false;
            } else if (attributesList[`${i}`].Name?.includes('EventProduct')) {
                eventProduct = attributesList[`${i}`].BooleanValue ? attributesList[`${i}`].BooleanValue! : false;
            }
        }

        return {
            formName: formName,
            amounts: amountArray,
            noOfNames: names,
            companyNames: companyNames,
            deceasedNames: deceasedNames,
            subProductRecordId: subProductRecordId,
            hasSerial: hasSerial,
            eventProduct: eventProduct
        };
    } */

    /* private async _getEventsForProduct(ecommId: number) {
        const startDate = new Date();
        startDate.setHours(0, 0, 0, 0);

        const data = await getProductEventsByIdAsync(
            { callerContext: this.props.context.actionContext },
            this.props.config.isUat,
            startDate.toISOString(),
            ecommId.toString()
        );

        data.map(event => {
            const eventJson = JSON.parse(event);

            const eventObj: IEvent = {
                id: eventJson['EventId'],
                name: eventJson['Name'],
                startDateTime: eventJson['StartDateTime'],
                endDateTime: eventJson['EndDateTime'],
                startLunarDate: eventJson['StartLunarDate'],
                endLunarDate: eventJson['EndLunarDate']
            };

            this.eventRecords.push(eventObj);
        });

        this._checkRegistrationPeriod();
    } */

    private _checkRegistrationPeriod() {
        let availableRegistration = true;

        if (
            this.props.formName === 'categoryNamesAddressForm' ||
            this.props.formName === 'categoryNamesCollectionForm' ||
            this.props.formName === 'categoryNamesForm' ||
            this.props.formName === 'ceremonyForm' ||
            this.props.formName === 'eventDeceasedDedicatedByForm' ||
            this.props.formName === 'namesOnlyForm' ||
            this.props.formName === 'namesRemarksForm' ||
            this.props.formName === 'namesAddressContactnoForm' ||
            this.props.formName === 'eventsNextOfKinNameForm' ||
            this.props.formName === 'deceasedDedicatedByForm' ||
            this.props.formName === 'eventCategoryNamesForm' ||
            this.props.formName === 'nameBirthdaySchoolForm'
        ) {
            if (this.props.eventRecords.length === 0) {
                this.setState({ registrationClosed: true });
            } else {
                const latestEvent = this.props.eventRecords[this.props.eventRecords.length - 1];
                const eventStartDate = moment(latestEvent['startDateTime']);
                const currentTime = moment();

                if (currentTime.diff(eventStartDate, 'd') > 0) {
                    availableRegistration = false;

                    this.setState({ registrationClosed: true });
                }
            }
        }

        return availableRegistration;
    }

    private async _checkAvailableSerial() {
        let haveSerial = true;

        if (this.props.hasSerial) {
            const checkAvailableSerialResult = await checkAvailableSerialAsync(
                { callerContext: this.props.context.actionContext },
                this.props.config.isUat,
                this.props.data.product.result?.RecordId.toString()!
            );

            if (
                checkAvailableSerialResult &&
                typeof checkAvailableSerialResult === 'object' &&
                checkAvailableSerialResult['value'] === false
            ) {
                haveSerial = false;

                // If user is logged in and user has a serial name, item is considered available.

                this.setState({ itemUnavailable: true });
            }
        }

        return haveSerial;
    }

    private _checkUnderEventDatesLimit(): boolean {
        let count = 0;

        for (let i = 0; i < this.state.quantities.length; ++i) {
            count += this.state.quantities[`${i}`];

            if (count > this.eventDateLimit) {
                return false;
            }
        }

        return true;
    }

    private _handleOnClickPopup = () => {
        event?.preventDefault();
        this.setState({ showPopup: true, addRenewLamp: false });
    };

    private _handleClosePopup = () => {
        event?.preventDefault();
        this.setState({ showPopup: false, addRenewLamp: false });
    };

    private _handleProceedPopup = () => {
        event?.preventDefault();
        this.setState({ showPopup: false, addRenewLamp: true });
    };

    private _toSingaporeTimeZone = (value: string[]) => {
        return value.map(d => {
            if (d) {
                var date = new Date(d);
                var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

                if (utcDate.getFullYear() < 1982) {
                    utcDate.setHours(utcDate.getHours() - 7);
                } else {
                    utcDate.setHours(utcDate.getHours() - 8);
                }
                return utcDate.toISOString();
            }
            return d;
        });
    };
}

export default EcommProductDetailsFormView;
